import { createSlice } from '@reduxjs/toolkit';

export const ManufSlice = createSlice({
    name: "manufslice",
    initialState: {
      appId:3,
      actionList:[],
      actionDashboard:{
          selectedId:-1,
          actionList:[],
          actionObj:{},
          
      },
      menuList:[],
  
        mfprintingstatusList:[],
		mfprintingstatusDashboard:{
            selectedId:-1,
            showEdit:false,
            mfprintingstatusList:[],
            mfprintingstatusObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        mfstitchingstatusList:[],
		mfstitchingstatusDashboard:{
            selectedId:-1,
            showEdit:false,
            mfstitchingstatusList:[],
            mfstitchingstatusObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        mfdigitalstatusList:[],
		mfdigitalstatusDashboard:{
            selectedId:-1,
            showEdit:false,
            mfdigitalstatusList:[],
            mfdigitalstatusObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        mfdeliverypriorityList:[],
		mfdeliverypriorityDashboard:{
            selectedId:-1,
            showEdit:false,
            mfdeliverypriorityList:[],
            mfdeliverypriorityObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        mfprintingtypeList:[],
		mfprintingtypeDashboard:{
            selectedId:-1,
            showEdit:false,
            mfprintingtypeList:[],
            mfprintingtypeObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        mforderstatusList:[],
		mforderstatusDashboard:{
            selectedId:-1,
            showEdit:false,
            mforderstatusList:[],
            mforderstatusObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        mforderList:[],
		mforderDashboard:{
            selectedId:-1,
            showEdit:false,
            mforderList:[],
            mforderObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			partyname:'',
			executive:'',
			orderstatusid:''
            },
            
			updateMfOrderStatusModalOpen:false,
			manageMfOrderModalOpen:false,
			addMfOrderModalOpen:false,
			addMfProductModalOpen:false,
			orderToFactoryModalOpen:false,
			UpdateRemarksModalOpen:false,
			ShowProgressModalOpen:false,
			PrintJobTicketModalOpen:false,
			EditOrderInfoModalOpen:false,
            
        },
        mfpartyList:[],
		mfpartyDashboard:{
            selectedId:-1,
            showEdit:false,
            mfpartyList:[],
            mfpartyObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:'',
			mobile:''
            },
            
			ManagePartyModalOpen:false,
			SelectPartyModalOpen:false,
            
        },
        mfproductorderList:[],
		mfproductorderDashboard:{
            selectedId:-1,
            showEdit:false,
            mfproductorderList:[],
            mfproductorderObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			productname:'',
			deliverypriorityid:'',
			stitchingstatusid:'',
			digitalstatusid:'',
			productorderstatusid:'',
			partyname:''
            },
            
			updateProductOrderStatusModalOpen:false,
			AddMfProductOrderModalOpen:false,
			UpdateProductOrderModalOpen:false,
			CancelProductOrderModalOpen:false,
            
        },
        mfproductList:[],
		mfproductDashboard:{
            selectedId:-1,
            showEdit:false,
            mfproductList:[],
            mfproductObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:'',
			code:''
            },
            
			attachImageModalOpen:false,
			ManageProductModalOpen:false,
			LinkAssetModalOpen:false,
			ManageAssetsModalOpen:false,
			AssetViewerModalOpen:false,
			SendWhatisupMsgModalOpen:false,
            
        },
        mfproductorderstatusList:[],
		mfproductorderstatusDashboard:{
            selectedId:-1,
            showEdit:false,
            mfproductorderstatusList:[],
            mfproductorderstatusObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        businessprocessList:[],
		businessprocessDashboard:{
            selectedId:-1,
            showEdit:false,
            businessprocessList:[],
            businessprocessObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
			TaskMgmtModalOpen:false,
            
        },
        taskList:[],
		taskDashboard:{
            selectedId:-1,
            showEdit:false,
            taskList:[],
            taskObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        taskinstanceList:[],
		taskinstanceDashboard:{
            selectedId:-1,
            showEdit:false,
            taskinstanceList:[],
            taskinstanceObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
			UpdateStatusModalOpen:false,
            
        },
        tasktypeList:[],
		tasktypeDashboard:{
            selectedId:-1,
            showEdit:false,
            tasktypeList:[],
            tasktypeObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        factoryroleList:[],
		factoryroleDashboard:{
            selectedId:-1,
            showEdit:false,
            factoryroleList:[],
            factoryroleObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        taskstatusList:[],
		taskstatusDashboard:{
            selectedId:-1,
            showEdit:false,
            taskstatusList:[],
            taskstatusObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        inventoryList:[],
		inventoryDashboard:{
            selectedId:-1,
            showEdit:false,
            inventoryList:[],
            inventoryObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			productname:''
            },
            
			mannageInventoryModalOpen:false,
            
        },
        inventoryitemList:[],
		inventoryitemDashboard:{
            selectedId:-1,
            showEdit:false,
            inventoryitemList:[],
            inventoryitemObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			productname:''
            },
            
            
        },
        categoryList:[],
		categoryDashboard:{
            selectedId:-1,
            showEdit:false,
            categoryList:[],
            categoryObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
			productMappingModalOpen:false,
            
        },
        category2productList:[],
		category2productDashboard:{
            selectedId:-1,
            showEdit:false,
            category2productList:[],
            category2productObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
            },
            
            
        },
        stockoutreqList:[],
		stockoutreqDashboard:{
            selectedId:-1,
            showEdit:false,
            stockoutreqList:[],
            stockoutreqObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
			genStockOutReqModalOpen:false,
			genPDFpageModalOpen:false,
            
        },
        stockoutproductList:[],
		stockoutproductDashboard:{
            selectedId:-1,
            showEdit:false,
            stockoutproductList:[],
            stockoutproductObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        stockoutproducttoproductorderList:[],
		stockoutproducttoproductorderDashboard:{
            selectedId:-1,
            showEdit:false,
            stockoutproducttoproductorderList:[],
            stockoutproducttoproductorderObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        stockorderList:[],
		stockorderDashboard:{
            selectedId:-1,
            showEdit:false,
            stockorderList:[],
            stockorderObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
			AddStockOrderModalOpen:false,
			ManageStockOrderModalOpen:false,
			PrintStockOrderModalOpen:false,
            
        },
        stockorderproductList:[],
		stockorderproductDashboard:{
            selectedId:-1,
            showEdit:false,
            stockorderproductList:[],
            stockorderproductObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
			AddStockProductModalOpen:false,
			ManageStockProductModalOpen:false,
            
        },
        assetsList:[],
		assetsDashboard:{
            selectedId:-1,
            showEdit:false,
            assetsList:[],
            assetsObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        audienceList:[],
		audienceDashboard:{
            selectedId:-1,
            showEdit:false,
            audienceList:[],
            audienceObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:'',
			email:''
            },
            
            
        },
        templateList:[],
		templateDashboard:{
            selectedId:-1,
            showEdit:false,
            templateList:[],
            templateObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:'',
			assetname:''
            },
            
			TestCampaignModalOpen:false,
			RunCampaignModalOpen:false,
            
        },
        campaignList:[],
		campaignDashboard:{
            selectedId:-1,
            showEdit:false,
            campaignList:[],
            campaignObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			audienceemail:'',
			templatename:''
            },
            
            
        },
        campaigncenterList:[],
		campaigncenterDashboard:{
            selectedId:-1,
            showEdit:false,
            campaigncenterList:[],
            campaigncenterObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        workerList:[],
		workerDashboard:{
            selectedId:-1,
            showEdit:false,
            workerList:[],
            workerObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:'',
			skillname:''
            },
            
            
        },
        skillList:[],
		skillDashboard:{
            selectedId:-1,
            showEdit:false,
            skillList:[],
            skillObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        explevelList:[],
		explevelDashboard:{
            selectedId:-1,
            showEdit:false,
            explevelList:[],
            explevelObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
        product2skill2exp2rateList:[],
		product2skill2exp2rateDashboard:{
            selectedId:-1,
            showEdit:false,
            product2skill2exp2rateList:[],
            product2skill2exp2rateObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			skillname:'',
			productname:'',
			workername:''
            },
            
            
        },
        stitchingtaskList:[],
		stitchingtaskDashboard:{
            selectedId:-1,
            showEdit:false,
            stitchingtaskList:[],
            stitchingtaskObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:'',
			orderid:'',
			productname:'',
			workername:''
            },
            
			CollectWorkModalOpen:false,
			EditRateModalOpen:false,
			UpdateWorkerModalOpen:false,
            
        },
        reportdailyorderList:[],
		reportdailyorderDashboard:{
            selectedId:-1,
            showEdit:false,
            reportdailyorderList:[],
            reportdailyorderObj:{},
            sorting:{'column':'','asc':true},
            filterCriteria:{
                
			title:''
            },
            
            
        },
    },
    reducers: {
        
        setActionList: (state, action) =>{
            state.actionList=action.payload;
            state.actionDashboard.actionList=action.payload;
        },
        setSelectedActionId: (state, action)=>{
            state.actionDashboard.selectedId=action.payload;

            state.actionDashboard.actionObj = state.actionList[
                state.actionList.findIndex(actionObj=>actionObj.id===parseInt(action.payload))
            ];
        },

        
        /* Mfprintingstatus Reducer methods */
        setMfprintingstatusSorting: (state, action)=>{
            state.mfprintingstatusDashboard.sorting=action.payload;
        },
        setMfprintingstatusFilterCriteria : (state, action)=>{
            state.mfprintingstatusDashboard.filterCriteria=action.payload;
        },
        setShowEditForMfprintingstatus: (state,action)=>{
            state.mfprintingstatusDashboard.showEdit=action.payload;
            
        },
        addMfprintingstatusObj: (state, action)=>{
            state.mfprintingstatusList.unshift(action.payload);
            state.mfprintingstatusDashboard.mfprintingstatusList.unshift(action.payload);

            state.mfprintingstatusDashboard.mfprintingstatusObj=action.payload;
            state.mfprintingstatusDashboard.selectedId=action.payload.id;
        },
        updateMfprintingstatusObj: (state, action)=>{
            let index = state.mfprintingstatusList.map(mfprintingstatusObj=>mfprintingstatusObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.mfprintingstatusList[index]=action.payload;
            }

            index = state.mfprintingstatusDashboard.mfprintingstatusList.map(mfprintingstatusObj=>mfprintingstatusObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.mfprintingstatusDashboard.mfprintingstatusList[index]=action.payload;
            }
            if (state.mfprintingstatusDashboard.mfprintingstatusObj!==null){
                state.mfprintingstatusDashboard.mfprintingstatusObj = action.payload;
            }
        },
        deleteMfprintingstatusObj: (state, action)=>{
            state.mfprintingstatusList.splice(state.mfprintingstatusList.findIndex(a => a.id === action.payload) , 1);
            state.mfprintingstatusDashboard.mfprintingstatusList.splice(state.mfprintingstatusDashboard.mfprintingstatusList.findIndex(a => a.id === action.payload) , 1);
            state.mfprintingstatusDashboard.productObj={}
            state.mfprintingstatusDashboard.selectedId=-1
        },
        setSelectedMfprintingstatusId: (state, action)=>{
            if (action.payload!==-1){
                state.mfprintingstatusDashboard.selectedId=action.payload;
                state.mfprintingstatusDashboard.mfprintingstatusObj = state.mfprintingstatusList[
                    state.mfprintingstatusList.findIndex(mfprintingstatusObj=>mfprintingstatusObj.id===parseInt(action.payload))
            ];
            } else {
                state.mfprintingstatusDashboard.selectedId=action.payload;
                state.mfprintingstatusDashboard.mfprintingstatusObj ={}
            }
        },
        setMfprintingstatusList: (state, action) =>{
            state.mfprintingstatusList=action.payload;
            state.mfprintingstatusDashboard.mfprintingstatusList=action.payload;
        },
        setMfprintingstatusDashboardMfprintingstatusList: (state, action) =>{
            state.mfprintingstatusDashboard.mfprintingstatusList=action.payload;
        },
        /* Mfstitchingstatus Reducer methods */
        setMfstitchingstatusSorting: (state, action)=>{
            state.mfstitchingstatusDashboard.sorting=action.payload;
        },
        setMfstitchingstatusFilterCriteria : (state, action)=>{
            state.mfstitchingstatusDashboard.filterCriteria=action.payload;
        },
        setShowEditForMfstitchingstatus: (state,action)=>{
            state.mfstitchingstatusDashboard.showEdit=action.payload;
            
        },
        addMfstitchingstatusObj: (state, action)=>{
            state.mfstitchingstatusList.unshift(action.payload);
            state.mfstitchingstatusDashboard.mfstitchingstatusList.unshift(action.payload);

            state.mfstitchingstatusDashboard.mfstitchingstatusObj=action.payload;
            state.mfstitchingstatusDashboard.selectedId=action.payload.id;
        },
        updateMfstitchingstatusObj: (state, action)=>{
            let index = state.mfstitchingstatusList.map(mfstitchingstatusObj=>mfstitchingstatusObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.mfstitchingstatusList[index]=action.payload;
            }

            index = state.mfstitchingstatusDashboard.mfstitchingstatusList.map(mfstitchingstatusObj=>mfstitchingstatusObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.mfstitchingstatusDashboard.mfstitchingstatusList[index]=action.payload;
            }
            if (state.mfstitchingstatusDashboard.mfstitchingstatusObj!==null){
                state.mfstitchingstatusDashboard.mfstitchingstatusObj = action.payload;
            }
        },
        deleteMfstitchingstatusObj: (state, action)=>{
            state.mfstitchingstatusList.splice(state.mfstitchingstatusList.findIndex(a => a.id === action.payload) , 1);
            state.mfstitchingstatusDashboard.mfstitchingstatusList.splice(state.mfstitchingstatusDashboard.mfstitchingstatusList.findIndex(a => a.id === action.payload) , 1);
            state.mfstitchingstatusDashboard.productObj={}
            state.mfstitchingstatusDashboard.selectedId=-1
        },
        setSelectedMfstitchingstatusId: (state, action)=>{
            if (action.payload!==-1){
                state.mfstitchingstatusDashboard.selectedId=action.payload;
                state.mfstitchingstatusDashboard.mfstitchingstatusObj = state.mfstitchingstatusList[
                    state.mfstitchingstatusList.findIndex(mfstitchingstatusObj=>mfstitchingstatusObj.id===parseInt(action.payload))
            ];
            } else {
                state.mfstitchingstatusDashboard.selectedId=action.payload;
                state.mfstitchingstatusDashboard.mfstitchingstatusObj ={}
            }
        },
        setMfstitchingstatusList: (state, action) =>{
            state.mfstitchingstatusList=action.payload;
            state.mfstitchingstatusDashboard.mfstitchingstatusList=action.payload;
        },
        setMfstitchingstatusDashboardMfstitchingstatusList: (state, action) =>{
            state.mfstitchingstatusDashboard.mfstitchingstatusList=action.payload;
        },
        /* Mfdigitalstatus Reducer methods */
        setMfdigitalstatusSorting: (state, action)=>{
            state.mfdigitalstatusDashboard.sorting=action.payload;
        },
        setMfdigitalstatusFilterCriteria : (state, action)=>{
            state.mfdigitalstatusDashboard.filterCriteria=action.payload;
        },
        setShowEditForMfdigitalstatus: (state,action)=>{
            state.mfdigitalstatusDashboard.showEdit=action.payload;
            
        },
        addMfdigitalstatusObj: (state, action)=>{
            state.mfdigitalstatusList.unshift(action.payload);
            state.mfdigitalstatusDashboard.mfdigitalstatusList.unshift(action.payload);

            state.mfdigitalstatusDashboard.mfdigitalstatusObj=action.payload;
            state.mfdigitalstatusDashboard.selectedId=action.payload.id;
        },
        updateMfdigitalstatusObj: (state, action)=>{
            let index = state.mfdigitalstatusList.map(mfdigitalstatusObj=>mfdigitalstatusObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.mfdigitalstatusList[index]=action.payload;
            }

            index = state.mfdigitalstatusDashboard.mfdigitalstatusList.map(mfdigitalstatusObj=>mfdigitalstatusObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.mfdigitalstatusDashboard.mfdigitalstatusList[index]=action.payload;
            }
            if (state.mfdigitalstatusDashboard.mfdigitalstatusObj!==null){
                state.mfdigitalstatusDashboard.mfdigitalstatusObj = action.payload;
            }
        },
        deleteMfdigitalstatusObj: (state, action)=>{
            state.mfdigitalstatusList.splice(state.mfdigitalstatusList.findIndex(a => a.id === action.payload) , 1);
            state.mfdigitalstatusDashboard.mfdigitalstatusList.splice(state.mfdigitalstatusDashboard.mfdigitalstatusList.findIndex(a => a.id === action.payload) , 1);
            state.mfdigitalstatusDashboard.productObj={}
            state.mfdigitalstatusDashboard.selectedId=-1
        },
        setSelectedMfdigitalstatusId: (state, action)=>{
            if (action.payload!==-1){
                state.mfdigitalstatusDashboard.selectedId=action.payload;
                state.mfdigitalstatusDashboard.mfdigitalstatusObj = state.mfdigitalstatusList[
                    state.mfdigitalstatusList.findIndex(mfdigitalstatusObj=>mfdigitalstatusObj.id===parseInt(action.payload))
            ];
            } else {
                state.mfdigitalstatusDashboard.selectedId=action.payload;
                state.mfdigitalstatusDashboard.mfdigitalstatusObj ={}
            }
        },
        setMfdigitalstatusList: (state, action) =>{
            state.mfdigitalstatusList=action.payload;
            state.mfdigitalstatusDashboard.mfdigitalstatusList=action.payload;
        },
        setMfdigitalstatusDashboardMfdigitalstatusList: (state, action) =>{
            state.mfdigitalstatusDashboard.mfdigitalstatusList=action.payload;
        },
        /* Mfdeliverypriority Reducer methods */
        setMfdeliveryprioritySorting: (state, action)=>{
            state.mfdeliverypriorityDashboard.sorting=action.payload;
        },
        setMfdeliverypriorityFilterCriteria : (state, action)=>{
            state.mfdeliverypriorityDashboard.filterCriteria=action.payload;
        },
        setShowEditForMfdeliverypriority: (state,action)=>{
            state.mfdeliverypriorityDashboard.showEdit=action.payload;
            
        },
        addMfdeliverypriorityObj: (state, action)=>{
            state.mfdeliverypriorityList.unshift(action.payload);
            state.mfdeliverypriorityDashboard.mfdeliverypriorityList.unshift(action.payload);

            state.mfdeliverypriorityDashboard.mfdeliverypriorityObj=action.payload;
            state.mfdeliverypriorityDashboard.selectedId=action.payload.id;
        },
        updateMfdeliverypriorityObj: (state, action)=>{
            let index = state.mfdeliverypriorityList.map(mfdeliverypriorityObj=>mfdeliverypriorityObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.mfdeliverypriorityList[index]=action.payload;
            }

            index = state.mfdeliverypriorityDashboard.mfdeliverypriorityList.map(mfdeliverypriorityObj=>mfdeliverypriorityObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.mfdeliverypriorityDashboard.mfdeliverypriorityList[index]=action.payload;
            }
            if (state.mfdeliverypriorityDashboard.mfdeliverypriorityObj!==null){
                state.mfdeliverypriorityDashboard.mfdeliverypriorityObj = action.payload;
            }
        },
        deleteMfdeliverypriorityObj: (state, action)=>{
            state.mfdeliverypriorityList.splice(state.mfdeliverypriorityList.findIndex(a => a.id === action.payload) , 1);
            state.mfdeliverypriorityDashboard.mfdeliverypriorityList.splice(state.mfdeliverypriorityDashboard.mfdeliverypriorityList.findIndex(a => a.id === action.payload) , 1);
            state.mfdeliverypriorityDashboard.productObj={}
            state.mfdeliverypriorityDashboard.selectedId=-1
        },
        setSelectedMfdeliverypriorityId: (state, action)=>{
            if (action.payload!==-1){
                state.mfdeliverypriorityDashboard.selectedId=action.payload;
                state.mfdeliverypriorityDashboard.mfdeliverypriorityObj = state.mfdeliverypriorityList[
                    state.mfdeliverypriorityList.findIndex(mfdeliverypriorityObj=>mfdeliverypriorityObj.id===parseInt(action.payload))
            ];
            } else {
                state.mfdeliverypriorityDashboard.selectedId=action.payload;
                state.mfdeliverypriorityDashboard.mfdeliverypriorityObj ={}
            }
        },
        setMfdeliverypriorityList: (state, action) =>{
            state.mfdeliverypriorityList=action.payload;
            state.mfdeliverypriorityDashboard.mfdeliverypriorityList=action.payload;
        },
        setMfdeliverypriorityDashboardMfdeliverypriorityList: (state, action) =>{
            state.mfdeliverypriorityDashboard.mfdeliverypriorityList=action.payload;
        },
        /* Mfprintingtype Reducer methods */
        setMfprintingtypeSorting: (state, action)=>{
            state.mfprintingtypeDashboard.sorting=action.payload;
        },
        setMfprintingtypeFilterCriteria : (state, action)=>{
            state.mfprintingtypeDashboard.filterCriteria=action.payload;
        },
        setShowEditForMfprintingtype: (state,action)=>{
            state.mfprintingtypeDashboard.showEdit=action.payload;
            
        },
        addMfprintingtypeObj: (state, action)=>{
            state.mfprintingtypeList.unshift(action.payload);
            state.mfprintingtypeDashboard.mfprintingtypeList.unshift(action.payload);

            state.mfprintingtypeDashboard.mfprintingtypeObj=action.payload;
            state.mfprintingtypeDashboard.selectedId=action.payload.id;
        },
        updateMfprintingtypeObj: (state, action)=>{
            let index = state.mfprintingtypeList.map(mfprintingtypeObj=>mfprintingtypeObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.mfprintingtypeList[index]=action.payload;
            }

            index = state.mfprintingtypeDashboard.mfprintingtypeList.map(mfprintingtypeObj=>mfprintingtypeObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.mfprintingtypeDashboard.mfprintingtypeList[index]=action.payload;
            }
            if (state.mfprintingtypeDashboard.mfprintingtypeObj!==null){
                state.mfprintingtypeDashboard.mfprintingtypeObj = action.payload;
            }
        },
        deleteMfprintingtypeObj: (state, action)=>{
            state.mfprintingtypeList.splice(state.mfprintingtypeList.findIndex(a => a.id === action.payload) , 1);
            state.mfprintingtypeDashboard.mfprintingtypeList.splice(state.mfprintingtypeDashboard.mfprintingtypeList.findIndex(a => a.id === action.payload) , 1);
            state.mfprintingtypeDashboard.productObj={}
            state.mfprintingtypeDashboard.selectedId=-1
        },
        setSelectedMfprintingtypeId: (state, action)=>{
            if (action.payload!==-1){
                state.mfprintingtypeDashboard.selectedId=action.payload;
                state.mfprintingtypeDashboard.mfprintingtypeObj = state.mfprintingtypeList[
                    state.mfprintingtypeList.findIndex(mfprintingtypeObj=>mfprintingtypeObj.id===parseInt(action.payload))
            ];
            } else {
                state.mfprintingtypeDashboard.selectedId=action.payload;
                state.mfprintingtypeDashboard.mfprintingtypeObj ={}
            }
        },
        setMfprintingtypeList: (state, action) =>{
            state.mfprintingtypeList=action.payload;
            state.mfprintingtypeDashboard.mfprintingtypeList=action.payload;
        },
        setMfprintingtypeDashboardMfprintingtypeList: (state, action) =>{
            state.mfprintingtypeDashboard.mfprintingtypeList=action.payload;
        },
        /* Mforderstatus Reducer methods */
        setMforderstatusSorting: (state, action)=>{
            state.mforderstatusDashboard.sorting=action.payload;
        },
        setMforderstatusFilterCriteria : (state, action)=>{
            state.mforderstatusDashboard.filterCriteria=action.payload;
        },
        setShowEditForMforderstatus: (state,action)=>{
            state.mforderstatusDashboard.showEdit=action.payload;
            
        },
        addMforderstatusObj: (state, action)=>{
            state.mforderstatusList.unshift(action.payload);
            state.mforderstatusDashboard.mforderstatusList.unshift(action.payload);

            state.mforderstatusDashboard.mforderstatusObj=action.payload;
            state.mforderstatusDashboard.selectedId=action.payload.id;
        },
        updateMforderstatusObj: (state, action)=>{
            let index = state.mforderstatusList.map(mforderstatusObj=>mforderstatusObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.mforderstatusList[index]=action.payload;
            }

            index = state.mforderstatusDashboard.mforderstatusList.map(mforderstatusObj=>mforderstatusObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.mforderstatusDashboard.mforderstatusList[index]=action.payload;
            }
            if (state.mforderstatusDashboard.mforderstatusObj!==null){
                state.mforderstatusDashboard.mforderstatusObj = action.payload;
            }
        },
        deleteMforderstatusObj: (state, action)=>{
            state.mforderstatusList.splice(state.mforderstatusList.findIndex(a => a.id === action.payload) , 1);
            state.mforderstatusDashboard.mforderstatusList.splice(state.mforderstatusDashboard.mforderstatusList.findIndex(a => a.id === action.payload) , 1);
            state.mforderstatusDashboard.productObj={}
            state.mforderstatusDashboard.selectedId=-1
        },
        setSelectedMforderstatusId: (state, action)=>{
            if (action.payload!==-1){
                state.mforderstatusDashboard.selectedId=action.payload;
                state.mforderstatusDashboard.mforderstatusObj = state.mforderstatusList[
                    state.mforderstatusList.findIndex(mforderstatusObj=>mforderstatusObj.id===parseInt(action.payload))
            ];
            } else {
                state.mforderstatusDashboard.selectedId=action.payload;
                state.mforderstatusDashboard.mforderstatusObj ={}
            }
        },
        setMforderstatusList: (state, action) =>{
            state.mforderstatusList=action.payload;
            state.mforderstatusDashboard.mforderstatusList=action.payload;
        },
        setMforderstatusDashboardMforderstatusList: (state, action) =>{
            state.mforderstatusDashboard.mforderstatusList=action.payload;
        },
        /* Mforder Reducer methods */
        setMforderSorting: (state, action)=>{
            state.mforderDashboard.sorting=action.payload;
        },
        setMforderFilterCriteria : (state, action)=>{
            state.mforderDashboard.filterCriteria=action.payload;
        },
        setShowEditForMforder: (state,action)=>{
            state.mforderDashboard.showEdit=action.payload;
            
			state.mforderDashboard.updateMfOrderStatusModalOpen=false;
			state.mforderDashboard.manageMfOrderModalOpen=false;
			state.mforderDashboard.addMfOrderModalOpen=false;
			state.mforderDashboard.addMfProductModalOpen=false;
			state.mforderDashboard.orderToFactoryModalOpen=false;
			state.mforderDashboard.UpdateRemarksModalOpen=false;
			state.mforderDashboard.ShowProgressModalOpen=false;
			state.mforderDashboard.PrintJobTicketModalOpen=false;
			state.mforderDashboard.EditOrderInfoModalOpen=false;
        },
        addMforderObj: (state, action)=>{
            state.mforderList.unshift(action.payload);
            state.mforderDashboard.mforderList.unshift(action.payload);

            state.mforderDashboard.mforderObj=action.payload;
            state.mforderDashboard.selectedId=action.payload.id;
        },
        updateMforderObj: (state, action)=>{
            let index = state.mforderList.map(mforderObj=>mforderObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.mforderList[index]=action.payload;
            }

            index = state.mforderDashboard.mforderList.map(mforderObj=>mforderObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.mforderDashboard.mforderList[index]=action.payload;
            }
            if (state.mforderDashboard.mforderObj!==null){
                state.mforderDashboard.mforderObj = action.payload;
            }
        },
        deleteMforderObj: (state, action)=>{
            state.mforderList.splice(state.mforderList.findIndex(a => a.id === action.payload) , 1);
            state.mforderDashboard.mforderList.splice(state.mforderDashboard.mforderList.findIndex(a => a.id === action.payload) , 1);
            state.mforderDashboard.productObj={}
            state.mforderDashboard.selectedId=-1
        },
        setSelectedMforderId: (state, action)=>{
            if (action.payload!==-1){
                state.mforderDashboard.selectedId=action.payload;
                state.mforderDashboard.mforderObj = state.mforderList[
                    state.mforderList.findIndex(mforderObj=>mforderObj.id===parseInt(action.payload))
            ];
            } else {
                state.mforderDashboard.selectedId=action.payload;
                state.mforderDashboard.mforderObj ={}
            }
        },
        setMforderList: (state, action) =>{
            state.mforderList=action.payload;
            state.mforderDashboard.mforderList=action.payload;
        },
        setMforderDashboardMforderList: (state, action) =>{
            state.mforderDashboard.mforderList=action.payload;
        },
      
        setMforderUpdateMfOrderStatusModal:(state,action)=>{
          state.mforderDashboard.updateMfOrderStatusModalOpen=action.payload;
        },
      
        setMforderManageMfOrderModal:(state,action)=>{
          state.mforderDashboard.manageMfOrderModalOpen=action.payload;
        },
      
        setMforderAddMfOrderModal:(state,action)=>{
          state.mforderDashboard.addMfOrderModalOpen=action.payload;
        },
      
        setMforderAddMfProductModal:(state,action)=>{
          state.mforderDashboard.addMfProductModalOpen=action.payload;
        },
      
        setMforderOrderToFactoryModal:(state,action)=>{
          state.mforderDashboard.orderToFactoryModalOpen=action.payload;
        },
      
        setMforderUpdateRemarksModal:(state,action)=>{
          state.mforderDashboard.UpdateRemarksModalOpen=action.payload;
        },
      
        setMforderShowProgressModal:(state,action)=>{
          state.mforderDashboard.ShowProgressModalOpen=action.payload;
        },
      
        setMforderPrintJobTicketModal:(state,action)=>{
          state.mforderDashboard.PrintJobTicketModalOpen=action.payload;
        },
      
        setMforderEditOrderInfoModal:(state,action)=>{
          state.mforderDashboard.EditOrderInfoModalOpen=action.payload;
        },
        /* Mfparty Reducer methods */
        setMfpartySorting: (state, action)=>{
            state.mfpartyDashboard.sorting=action.payload;
        },
        setMfpartyFilterCriteria : (state, action)=>{
            state.mfpartyDashboard.filterCriteria=action.payload;
        },
        setShowEditForMfparty: (state,action)=>{
            state.mfpartyDashboard.showEdit=action.payload;
            
			state.mfpartyDashboard.ManagePartyModalOpen=false;
			state.mfpartyDashboard.SelectPartyModalOpen=false;
        },
        addMfpartyObj: (state, action)=>{
            state.mfpartyList.unshift(action.payload);
            state.mfpartyDashboard.mfpartyList.unshift(action.payload);

            state.mfpartyDashboard.mfpartyObj=action.payload;
            state.mfpartyDashboard.selectedId=action.payload.id;
        },
        updateMfpartyObj: (state, action)=>{
            let index = state.mfpartyList.map(mfpartyObj=>mfpartyObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.mfpartyList[index]=action.payload;
            }

            index = state.mfpartyDashboard.mfpartyList.map(mfpartyObj=>mfpartyObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.mfpartyDashboard.mfpartyList[index]=action.payload;
            }
            if (state.mfpartyDashboard.mfpartyObj!==null){
                state.mfpartyDashboard.mfpartyObj = action.payload;
            }
        },
        deleteMfpartyObj: (state, action)=>{
            state.mfpartyList.splice(state.mfpartyList.findIndex(a => a.id === action.payload) , 1);
            state.mfpartyDashboard.mfpartyList.splice(state.mfpartyDashboard.mfpartyList.findIndex(a => a.id === action.payload) , 1);
            state.mfpartyDashboard.productObj={}
            state.mfpartyDashboard.selectedId=-1
        },
        setSelectedMfpartyId: (state, action)=>{
            if (action.payload!==-1){
                state.mfpartyDashboard.selectedId=action.payload;
                state.mfpartyDashboard.mfpartyObj = state.mfpartyList[
                    state.mfpartyList.findIndex(mfpartyObj=>mfpartyObj.id===parseInt(action.payload))
            ];
            } else {
                state.mfpartyDashboard.selectedId=action.payload;
                state.mfpartyDashboard.mfpartyObj ={}
            }
        },
        setMfpartyList: (state, action) =>{
            state.mfpartyList=action.payload;
            state.mfpartyDashboard.mfpartyList=action.payload;
        },
        setMfpartyDashboardMfpartyList: (state, action) =>{
            state.mfpartyDashboard.mfpartyList=action.payload;
        },
      
        setMfpartyManagePartyModal:(state,action)=>{
          state.mfpartyDashboard.ManagePartyModalOpen=action.payload;
        },
      
        setMfpartySelectPartyModal:(state,action)=>{
          state.mfpartyDashboard.SelectPartyModalOpen=action.payload;
        },
        /* Mfproductorder Reducer methods */
        setMfproductorderSorting: (state, action)=>{
            state.mfproductorderDashboard.sorting=action.payload;
        },
        setMfproductorderFilterCriteria : (state, action)=>{
            state.mfproductorderDashboard.filterCriteria=action.payload;
        },
        setShowEditForMfproductorder: (state,action)=>{
            state.mfproductorderDashboard.showEdit=action.payload;
            
			state.mfproductorderDashboard.updateProductOrderStatusModalOpen=false;
			state.mfproductorderDashboard.AddMfProductOrderModalOpen=false;
			state.mfproductorderDashboard.UpdateProductOrderModalOpen=false;
			state.mfproductorderDashboard.CancelProductOrderModalOpen=false;
        },
        addMfproductorderObj: (state, action)=>{
            state.mfproductorderList.unshift(action.payload);
            state.mfproductorderDashboard.mfproductorderList.unshift(action.payload);

            state.mfproductorderDashboard.mfproductorderObj=action.payload;
            state.mfproductorderDashboard.selectedId=action.payload.id;
        },
        updateMfproductorderObj: (state, action)=>{
            let index = state.mfproductorderList.map(mfproductorderObj=>mfproductorderObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.mfproductorderList[index]=action.payload;
            }

            index = state.mfproductorderDashboard.mfproductorderList.map(mfproductorderObj=>mfproductorderObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.mfproductorderDashboard.mfproductorderList[index]=action.payload;
            }
            if (state.mfproductorderDashboard.mfproductorderObj!==null){
                state.mfproductorderDashboard.mfproductorderObj = action.payload;
            }
        },
        deleteMfproductorderObj: (state, action)=>{
            state.mfproductorderList.splice(state.mfproductorderList.findIndex(a => a.id === action.payload) , 1);
            state.mfproductorderDashboard.mfproductorderList.splice(state.mfproductorderDashboard.mfproductorderList.findIndex(a => a.id === action.payload) , 1);
            state.mfproductorderDashboard.productObj={}
            state.mfproductorderDashboard.selectedId=-1
        },
        setSelectedMfproductorderId: (state, action)=>{
            if (action.payload!==-1){
                state.mfproductorderDashboard.selectedId=action.payload;
                state.mfproductorderDashboard.mfproductorderObj = state.mfproductorderList[
                    state.mfproductorderList.findIndex(mfproductorderObj=>mfproductorderObj.id===parseInt(action.payload))
            ];
            } else {
                state.mfproductorderDashboard.selectedId=action.payload;
                state.mfproductorderDashboard.mfproductorderObj ={}
            }
        },
        setMfproductorderList: (state, action) =>{
            state.mfproductorderList=action.payload;
            state.mfproductorderDashboard.mfproductorderList=action.payload;
        },
        setMfproductorderDashboardMfproductorderList: (state, action) =>{
            state.mfproductorderDashboard.mfproductorderList=action.payload;
        },
      
        setMfproductorderUpdateProductOrderStatusModal:(state,action)=>{
          state.mfproductorderDashboard.updateProductOrderStatusModalOpen=action.payload;
        },
      
        setMfproductorderAddMfProductOrderModal:(state,action)=>{
          state.mfproductorderDashboard.AddMfProductOrderModalOpen=action.payload;
        },
      
        setMfproductorderUpdateProductOrderModal:(state,action)=>{
          state.mfproductorderDashboard.UpdateProductOrderModalOpen=action.payload;
        },
      
        setMfproductorderCancelProductOrderModal:(state,action)=>{
          state.mfproductorderDashboard.CancelProductOrderModalOpen=action.payload;
        },
        /* Mfproduct Reducer methods */
        setMfproductSorting: (state, action)=>{
            state.mfproductDashboard.sorting=action.payload;
        },
        setMfproductFilterCriteria : (state, action)=>{
            state.mfproductDashboard.filterCriteria=action.payload;
        },
        setShowEditForMfproduct: (state,action)=>{
            state.mfproductDashboard.showEdit=action.payload;
            
			state.mfproductDashboard.attachImageModalOpen=false;
			state.mfproductDashboard.ManageProductModalOpen=false;
			state.mfproductDashboard.LinkAssetModalOpen=false;
			state.mfproductDashboard.ManageAssetsModalOpen=false;
			state.mfproductDashboard.AssetViewerModalOpen=false;
			state.mfproductDashboard.SendWhatisupMsgModalOpen=false;
        },
        addMfproductObj: (state, action)=>{
            state.mfproductList.unshift(action.payload);
            state.mfproductDashboard.mfproductList.unshift(action.payload);

            state.mfproductDashboard.mfproductObj=action.payload;
            state.mfproductDashboard.selectedId=action.payload.id;
        },
        updateMfproductObj: (state, action)=>{
            let index = state.mfproductList.map(mfproductObj=>mfproductObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.mfproductList[index]=action.payload;
            }

            index = state.mfproductDashboard.mfproductList.map(mfproductObj=>mfproductObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.mfproductDashboard.mfproductList[index]=action.payload;
            }
            if (state.mfproductDashboard.mfproductObj!==null){
                state.mfproductDashboard.mfproductObj = action.payload;
            }
        },
        deleteMfproductObj: (state, action)=>{
            state.mfproductList.splice(state.mfproductList.findIndex(a => a.id === action.payload) , 1);
            state.mfproductDashboard.mfproductList.splice(state.mfproductDashboard.mfproductList.findIndex(a => a.id === action.payload) , 1);
            state.mfproductDashboard.productObj={}
            state.mfproductDashboard.selectedId=-1
        },
        setSelectedMfproductId: (state, action)=>{
            if (action.payload!==-1){
                state.mfproductDashboard.selectedId=action.payload;
                state.mfproductDashboard.mfproductObj = state.mfproductList[
                    state.mfproductList.findIndex(mfproductObj=>mfproductObj.id===parseInt(action.payload))
            ];
            } else {
                state.mfproductDashboard.selectedId=action.payload;
                state.mfproductDashboard.mfproductObj ={}
            }
        },
        setMfproductList: (state, action) =>{
            state.mfproductList=action.payload;
            state.mfproductDashboard.mfproductList=action.payload;
        },
        setMfproductDashboardMfproductList: (state, action) =>{
            state.mfproductDashboard.mfproductList=action.payload;
        },
      
        setMfproductAttachImageModal:(state,action)=>{
          state.mfproductDashboard.attachImageModalOpen=action.payload;
        },
      
        setMfproductManageProductModal:(state,action)=>{
          state.mfproductDashboard.ManageProductModalOpen=action.payload;
        },
      
        setMfproductLinkAssetModal:(state,action)=>{
          state.mfproductDashboard.LinkAssetModalOpen=action.payload;
        },
      
        setMfproductManageAssetsModal:(state,action)=>{
          state.mfproductDashboard.ManageAssetsModalOpen=action.payload;
        },
      
        setMfproductAssetViewerModal:(state,action)=>{
          state.mfproductDashboard.AssetViewerModalOpen=action.payload;
        },
      
        setMfproductSendWhatisupMsgModal:(state,action)=>{
          state.mfproductDashboard.SendWhatisupMsgModalOpen=action.payload;
        },
        /* Mfproductorderstatus Reducer methods */
        setMfproductorderstatusSorting: (state, action)=>{
            state.mfproductorderstatusDashboard.sorting=action.payload;
        },
        setMfproductorderstatusFilterCriteria : (state, action)=>{
            state.mfproductorderstatusDashboard.filterCriteria=action.payload;
        },
        setShowEditForMfproductorderstatus: (state,action)=>{
            state.mfproductorderstatusDashboard.showEdit=action.payload;
            
        },
        addMfproductorderstatusObj: (state, action)=>{
            state.mfproductorderstatusList.unshift(action.payload);
            state.mfproductorderstatusDashboard.mfproductorderstatusList.unshift(action.payload);

            state.mfproductorderstatusDashboard.mfproductorderstatusObj=action.payload;
            state.mfproductorderstatusDashboard.selectedId=action.payload.id;
        },
        updateMfproductorderstatusObj: (state, action)=>{
            let index = state.mfproductorderstatusList.map(mfproductorderstatusObj=>mfproductorderstatusObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.mfproductorderstatusList[index]=action.payload;
            }

            index = state.mfproductorderstatusDashboard.mfproductorderstatusList.map(mfproductorderstatusObj=>mfproductorderstatusObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.mfproductorderstatusDashboard.mfproductorderstatusList[index]=action.payload;
            }
            if (state.mfproductorderstatusDashboard.mfproductorderstatusObj!==null){
                state.mfproductorderstatusDashboard.mfproductorderstatusObj = action.payload;
            }
        },
        deleteMfproductorderstatusObj: (state, action)=>{
            state.mfproductorderstatusList.splice(state.mfproductorderstatusList.findIndex(a => a.id === action.payload) , 1);
            state.mfproductorderstatusDashboard.mfproductorderstatusList.splice(state.mfproductorderstatusDashboard.mfproductorderstatusList.findIndex(a => a.id === action.payload) , 1);
            state.mfproductorderstatusDashboard.productObj={}
            state.mfproductorderstatusDashboard.selectedId=-1
        },
        setSelectedMfproductorderstatusId: (state, action)=>{
            if (action.payload!==-1){
                state.mfproductorderstatusDashboard.selectedId=action.payload;
                state.mfproductorderstatusDashboard.mfproductorderstatusObj = state.mfproductorderstatusList[
                    state.mfproductorderstatusList.findIndex(mfproductorderstatusObj=>mfproductorderstatusObj.id===parseInt(action.payload))
            ];
            } else {
                state.mfproductorderstatusDashboard.selectedId=action.payload;
                state.mfproductorderstatusDashboard.mfproductorderstatusObj ={}
            }
        },
        setMfproductorderstatusList: (state, action) =>{
            state.mfproductorderstatusList=action.payload;
            state.mfproductorderstatusDashboard.mfproductorderstatusList=action.payload;
        },
        setMfproductorderstatusDashboardMfproductorderstatusList: (state, action) =>{
            state.mfproductorderstatusDashboard.mfproductorderstatusList=action.payload;
        },
        /* Businessprocess Reducer methods */
        setBusinessprocessSorting: (state, action)=>{
            state.businessprocessDashboard.sorting=action.payload;
        },
        setBusinessprocessFilterCriteria : (state, action)=>{
            state.businessprocessDashboard.filterCriteria=action.payload;
        },
        setShowEditForBusinessprocess: (state,action)=>{
            state.businessprocessDashboard.showEdit=action.payload;
            
			state.businessprocessDashboard.TaskMgmtModalOpen=false;
        },
        addBusinessprocessObj: (state, action)=>{
            state.businessprocessList.unshift(action.payload);
            state.businessprocessDashboard.businessprocessList.unshift(action.payload);

            state.businessprocessDashboard.businessprocessObj=action.payload;
            state.businessprocessDashboard.selectedId=action.payload.id;
        },
        updateBusinessprocessObj: (state, action)=>{
            let index = state.businessprocessList.map(businessprocessObj=>businessprocessObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.businessprocessList[index]=action.payload;
            }

            index = state.businessprocessDashboard.businessprocessList.map(businessprocessObj=>businessprocessObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.businessprocessDashboard.businessprocessList[index]=action.payload;
            }
            if (state.businessprocessDashboard.businessprocessObj!==null){
                state.businessprocessDashboard.businessprocessObj = action.payload;
            }
        },
        deleteBusinessprocessObj: (state, action)=>{
            state.businessprocessList.splice(state.businessprocessList.findIndex(a => a.id === action.payload) , 1);
            state.businessprocessDashboard.businessprocessList.splice(state.businessprocessDashboard.businessprocessList.findIndex(a => a.id === action.payload) , 1);
            state.businessprocessDashboard.productObj={}
            state.businessprocessDashboard.selectedId=-1
        },
        setSelectedBusinessprocessId: (state, action)=>{
            if (action.payload!==-1){
                state.businessprocessDashboard.selectedId=action.payload;
                state.businessprocessDashboard.businessprocessObj = state.businessprocessList[
                    state.businessprocessList.findIndex(businessprocessObj=>businessprocessObj.id===parseInt(action.payload))
            ];
            } else {
                state.businessprocessDashboard.selectedId=action.payload;
                state.businessprocessDashboard.businessprocessObj ={}
            }
        },
        setBusinessprocessList: (state, action) =>{
            state.businessprocessList=action.payload;
            state.businessprocessDashboard.businessprocessList=action.payload;
        },
        setBusinessprocessDashboardBusinessprocessList: (state, action) =>{
            state.businessprocessDashboard.businessprocessList=action.payload;
        },
      
        setBusinessprocessTaskMgmtModal:(state,action)=>{
          state.businessprocessDashboard.TaskMgmtModalOpen=action.payload;
        },
        /* Task Reducer methods */
        setTaskSorting: (state, action)=>{
            state.taskDashboard.sorting=action.payload;
        },
        setTaskFilterCriteria : (state, action)=>{
            state.taskDashboard.filterCriteria=action.payload;
        },
        setShowEditForTask: (state,action)=>{
            state.taskDashboard.showEdit=action.payload;
            
        },
        addTaskObj: (state, action)=>{
            state.taskList.unshift(action.payload);
            state.taskDashboard.taskList.unshift(action.payload);

            state.taskDashboard.taskObj=action.payload;
            state.taskDashboard.selectedId=action.payload.id;
        },
        updateTaskObj: (state, action)=>{
            let index = state.taskList.map(taskObj=>taskObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.taskList[index]=action.payload;
            }

            index = state.taskDashboard.taskList.map(taskObj=>taskObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.taskDashboard.taskList[index]=action.payload;
            }
            if (state.taskDashboard.taskObj!==null){
                state.taskDashboard.taskObj = action.payload;
            }
        },
        deleteTaskObj: (state, action)=>{
            state.taskList.splice(state.taskList.findIndex(a => a.id === action.payload) , 1);
            state.taskDashboard.taskList.splice(state.taskDashboard.taskList.findIndex(a => a.id === action.payload) , 1);
            state.taskDashboard.productObj={}
            state.taskDashboard.selectedId=-1
        },
        setSelectedTaskId: (state, action)=>{
            if (action.payload!==-1){
                state.taskDashboard.selectedId=action.payload;
                state.taskDashboard.taskObj = state.taskList[
                    state.taskList.findIndex(taskObj=>taskObj.id===parseInt(action.payload))
            ];
            } else {
                state.taskDashboard.selectedId=action.payload;
                state.taskDashboard.taskObj ={}
            }
        },
        setTaskList: (state, action) =>{
            state.taskList=action.payload;
            state.taskDashboard.taskList=action.payload;
        },
        setTaskDashboardTaskList: (state, action) =>{
            state.taskDashboard.taskList=action.payload;
        },
        /* Taskinstance Reducer methods */
        setTaskinstanceSorting: (state, action)=>{
            state.taskinstanceDashboard.sorting=action.payload;
        },
        setTaskinstanceFilterCriteria : (state, action)=>{
            state.taskinstanceDashboard.filterCriteria=action.payload;
        },
        setShowEditForTaskinstance: (state,action)=>{
            state.taskinstanceDashboard.showEdit=action.payload;
            
			state.taskinstanceDashboard.UpdateStatusModalOpen=false;
        },
        addTaskinstanceObj: (state, action)=>{
            state.taskinstanceList.unshift(action.payload);
            state.taskinstanceDashboard.taskinstanceList.unshift(action.payload);

            state.taskinstanceDashboard.taskinstanceObj=action.payload;
            state.taskinstanceDashboard.selectedId=action.payload.id;
        },
        updateTaskinstanceObj: (state, action)=>{
            let index = state.taskinstanceList.map(taskinstanceObj=>taskinstanceObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.taskinstanceList[index]=action.payload;
            }

            index = state.taskinstanceDashboard.taskinstanceList.map(taskinstanceObj=>taskinstanceObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.taskinstanceDashboard.taskinstanceList[index]=action.payload;
            }
            if (state.taskinstanceDashboard.taskinstanceObj!==null){
                state.taskinstanceDashboard.taskinstanceObj = action.payload;
            }
        },
        deleteTaskinstanceObj: (state, action)=>{
            state.taskinstanceList.splice(state.taskinstanceList.findIndex(a => a.id === action.payload) , 1);
            state.taskinstanceDashboard.taskinstanceList.splice(state.taskinstanceDashboard.taskinstanceList.findIndex(a => a.id === action.payload) , 1);
            state.taskinstanceDashboard.productObj={}
            state.taskinstanceDashboard.selectedId=-1
        },
        setSelectedTaskinstanceId: (state, action)=>{
            if (action.payload!==-1){
                state.taskinstanceDashboard.selectedId=action.payload;
                state.taskinstanceDashboard.taskinstanceObj = state.taskinstanceList[
                    state.taskinstanceList.findIndex(taskinstanceObj=>taskinstanceObj.id===parseInt(action.payload))
            ];
            } else {
                state.taskinstanceDashboard.selectedId=action.payload;
                state.taskinstanceDashboard.taskinstanceObj ={}
            }
        },
        setTaskinstanceList: (state, action) =>{
            state.taskinstanceList=action.payload;
            state.taskinstanceDashboard.taskinstanceList=action.payload;
        },
        setTaskinstanceDashboardTaskinstanceList: (state, action) =>{
            state.taskinstanceDashboard.taskinstanceList=action.payload;
        },
      
        setTaskinstanceUpdateStatusModal:(state,action)=>{
          state.taskinstanceDashboard.UpdateStatusModalOpen=action.payload;
        },
        /* Tasktype Reducer methods */
        setTasktypeSorting: (state, action)=>{
            state.tasktypeDashboard.sorting=action.payload;
        },
        setTasktypeFilterCriteria : (state, action)=>{
            state.tasktypeDashboard.filterCriteria=action.payload;
        },
        setShowEditForTasktype: (state,action)=>{
            state.tasktypeDashboard.showEdit=action.payload;
            
        },
        addTasktypeObj: (state, action)=>{
            state.tasktypeList.unshift(action.payload);
            state.tasktypeDashboard.tasktypeList.unshift(action.payload);

            state.tasktypeDashboard.tasktypeObj=action.payload;
            state.tasktypeDashboard.selectedId=action.payload.id;
        },
        updateTasktypeObj: (state, action)=>{
            let index = state.tasktypeList.map(tasktypeObj=>tasktypeObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.tasktypeList[index]=action.payload;
            }

            index = state.tasktypeDashboard.tasktypeList.map(tasktypeObj=>tasktypeObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.tasktypeDashboard.tasktypeList[index]=action.payload;
            }
            if (state.tasktypeDashboard.tasktypeObj!==null){
                state.tasktypeDashboard.tasktypeObj = action.payload;
            }
        },
        deleteTasktypeObj: (state, action)=>{
            state.tasktypeList.splice(state.tasktypeList.findIndex(a => a.id === action.payload) , 1);
            state.tasktypeDashboard.tasktypeList.splice(state.tasktypeDashboard.tasktypeList.findIndex(a => a.id === action.payload) , 1);
            state.tasktypeDashboard.productObj={}
            state.tasktypeDashboard.selectedId=-1
        },
        setSelectedTasktypeId: (state, action)=>{
            if (action.payload!==-1){
                state.tasktypeDashboard.selectedId=action.payload;
                state.tasktypeDashboard.tasktypeObj = state.tasktypeList[
                    state.tasktypeList.findIndex(tasktypeObj=>tasktypeObj.id===parseInt(action.payload))
            ];
            } else {
                state.tasktypeDashboard.selectedId=action.payload;
                state.tasktypeDashboard.tasktypeObj ={}
            }
        },
        setTasktypeList: (state, action) =>{
            state.tasktypeList=action.payload;
            state.tasktypeDashboard.tasktypeList=action.payload;
        },
        setTasktypeDashboardTasktypeList: (state, action) =>{
            state.tasktypeDashboard.tasktypeList=action.payload;
        },
        /* Factoryrole Reducer methods */
        setFactoryroleSorting: (state, action)=>{
            state.factoryroleDashboard.sorting=action.payload;
        },
        setFactoryroleFilterCriteria : (state, action)=>{
            state.factoryroleDashboard.filterCriteria=action.payload;
        },
        setShowEditForFactoryrole: (state,action)=>{
            state.factoryroleDashboard.showEdit=action.payload;
            
        },
        addFactoryroleObj: (state, action)=>{
            state.factoryroleList.unshift(action.payload);
            state.factoryroleDashboard.factoryroleList.unshift(action.payload);

            state.factoryroleDashboard.factoryroleObj=action.payload;
            state.factoryroleDashboard.selectedId=action.payload.id;
        },
        updateFactoryroleObj: (state, action)=>{
            let index = state.factoryroleList.map(factoryroleObj=>factoryroleObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.factoryroleList[index]=action.payload;
            }

            index = state.factoryroleDashboard.factoryroleList.map(factoryroleObj=>factoryroleObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.factoryroleDashboard.factoryroleList[index]=action.payload;
            }
            if (state.factoryroleDashboard.factoryroleObj!==null){
                state.factoryroleDashboard.factoryroleObj = action.payload;
            }
        },
        deleteFactoryroleObj: (state, action)=>{
            state.factoryroleList.splice(state.factoryroleList.findIndex(a => a.id === action.payload) , 1);
            state.factoryroleDashboard.factoryroleList.splice(state.factoryroleDashboard.factoryroleList.findIndex(a => a.id === action.payload) , 1);
            state.factoryroleDashboard.productObj={}
            state.factoryroleDashboard.selectedId=-1
        },
        setSelectedFactoryroleId: (state, action)=>{
            if (action.payload!==-1){
                state.factoryroleDashboard.selectedId=action.payload;
                state.factoryroleDashboard.factoryroleObj = state.factoryroleList[
                    state.factoryroleList.findIndex(factoryroleObj=>factoryroleObj.id===parseInt(action.payload))
            ];
            } else {
                state.factoryroleDashboard.selectedId=action.payload;
                state.factoryroleDashboard.factoryroleObj ={}
            }
        },
        setFactoryroleList: (state, action) =>{
            state.factoryroleList=action.payload;
            state.factoryroleDashboard.factoryroleList=action.payload;
        },
        setFactoryroleDashboardFactoryroleList: (state, action) =>{
            state.factoryroleDashboard.factoryroleList=action.payload;
        },
        /* Taskstatus Reducer methods */
        setTaskstatusSorting: (state, action)=>{
            state.taskstatusDashboard.sorting=action.payload;
        },
        setTaskstatusFilterCriteria : (state, action)=>{
            state.taskstatusDashboard.filterCriteria=action.payload;
        },
        setShowEditForTaskstatus: (state,action)=>{
            state.taskstatusDashboard.showEdit=action.payload;
            
        },
        addTaskstatusObj: (state, action)=>{
            state.taskstatusList.unshift(action.payload);
            state.taskstatusDashboard.taskstatusList.unshift(action.payload);

            state.taskstatusDashboard.taskstatusObj=action.payload;
            state.taskstatusDashboard.selectedId=action.payload.id;
        },
        updateTaskstatusObj: (state, action)=>{
            let index = state.taskstatusList.map(taskstatusObj=>taskstatusObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.taskstatusList[index]=action.payload;
            }

            index = state.taskstatusDashboard.taskstatusList.map(taskstatusObj=>taskstatusObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.taskstatusDashboard.taskstatusList[index]=action.payload;
            }
            if (state.taskstatusDashboard.taskstatusObj!==null){
                state.taskstatusDashboard.taskstatusObj = action.payload;
            }
        },
        deleteTaskstatusObj: (state, action)=>{
            state.taskstatusList.splice(state.taskstatusList.findIndex(a => a.id === action.payload) , 1);
            state.taskstatusDashboard.taskstatusList.splice(state.taskstatusDashboard.taskstatusList.findIndex(a => a.id === action.payload) , 1);
            state.taskstatusDashboard.productObj={}
            state.taskstatusDashboard.selectedId=-1
        },
        setSelectedTaskstatusId: (state, action)=>{
            if (action.payload!==-1){
                state.taskstatusDashboard.selectedId=action.payload;
                state.taskstatusDashboard.taskstatusObj = state.taskstatusList[
                    state.taskstatusList.findIndex(taskstatusObj=>taskstatusObj.id===parseInt(action.payload))
            ];
            } else {
                state.taskstatusDashboard.selectedId=action.payload;
                state.taskstatusDashboard.taskstatusObj ={}
            }
        },
        setTaskstatusList: (state, action) =>{
            state.taskstatusList=action.payload;
            state.taskstatusDashboard.taskstatusList=action.payload;
        },
        setTaskstatusDashboardTaskstatusList: (state, action) =>{
            state.taskstatusDashboard.taskstatusList=action.payload;
        },
        /* Inventory Reducer methods */
        setInventorySorting: (state, action)=>{
            state.inventoryDashboard.sorting=action.payload;
        },
        setInventoryFilterCriteria : (state, action)=>{
            state.inventoryDashboard.filterCriteria=action.payload;
        },
        setShowEditForInventory: (state,action)=>{
            state.inventoryDashboard.showEdit=action.payload;
            
			state.inventoryDashboard.mannageInventoryModalOpen=false;
        },
        addInventoryObj: (state, action)=>{
            state.inventoryList.unshift(action.payload);
            state.inventoryDashboard.inventoryList.unshift(action.payload);

            state.inventoryDashboard.inventoryObj=action.payload;
            state.inventoryDashboard.selectedId=action.payload.id;
        },
        updateInventoryObj: (state, action)=>{
            let index = state.inventoryList.map(inventoryObj=>inventoryObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.inventoryList[index]=action.payload;
            }

            index = state.inventoryDashboard.inventoryList.map(inventoryObj=>inventoryObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.inventoryDashboard.inventoryList[index]=action.payload;
            }
            if (state.inventoryDashboard.inventoryObj!==null){
                state.inventoryDashboard.inventoryObj = action.payload;
            }
        },
        deleteInventoryObj: (state, action)=>{
            state.inventoryList.splice(state.inventoryList.findIndex(a => a.id === action.payload) , 1);
            state.inventoryDashboard.inventoryList.splice(state.inventoryDashboard.inventoryList.findIndex(a => a.id === action.payload) , 1);
            state.inventoryDashboard.productObj={}
            state.inventoryDashboard.selectedId=-1
        },
        setSelectedInventoryId: (state, action)=>{
            if (action.payload!==-1){
                state.inventoryDashboard.selectedId=action.payload;
                state.inventoryDashboard.inventoryObj = state.inventoryList[
                    state.inventoryList.findIndex(inventoryObj=>inventoryObj.id===parseInt(action.payload))
            ];
            } else {
                state.inventoryDashboard.selectedId=action.payload;
                state.inventoryDashboard.inventoryObj ={}
            }
        },
        setInventoryList: (state, action) =>{
            state.inventoryList=action.payload;
            state.inventoryDashboard.inventoryList=action.payload;
        },
        setInventoryDashboardInventoryList: (state, action) =>{
            state.inventoryDashboard.inventoryList=action.payload;
        },
      
        setInventoryMannageInventoryModal:(state,action)=>{
          state.inventoryDashboard.mannageInventoryModalOpen=action.payload;
        },
        /* Inventoryitem Reducer methods */
        setInventoryitemSorting: (state, action)=>{
            state.inventoryitemDashboard.sorting=action.payload;
        },
        setInventoryitemFilterCriteria : (state, action)=>{
            state.inventoryitemDashboard.filterCriteria=action.payload;
        },
        setShowEditForInventoryitem: (state,action)=>{
            state.inventoryitemDashboard.showEdit=action.payload;
            
        },
        addInventoryitemObj: (state, action)=>{
            state.inventoryitemList.unshift(action.payload);
            state.inventoryitemDashboard.inventoryitemList.unshift(action.payload);

            state.inventoryitemDashboard.inventoryitemObj=action.payload;
            state.inventoryitemDashboard.selectedId=action.payload.id;
        },
        updateInventoryitemObj: (state, action)=>{
            let index = state.inventoryitemList.map(inventoryitemObj=>inventoryitemObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.inventoryitemList[index]=action.payload;
            }

            index = state.inventoryitemDashboard.inventoryitemList.map(inventoryitemObj=>inventoryitemObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.inventoryitemDashboard.inventoryitemList[index]=action.payload;
            }
            if (state.inventoryitemDashboard.inventoryitemObj!==null){
                state.inventoryitemDashboard.inventoryitemObj = action.payload;
            }
        },
        deleteInventoryitemObj: (state, action)=>{
            state.inventoryitemList.splice(state.inventoryitemList.findIndex(a => a.id === action.payload) , 1);
            state.inventoryitemDashboard.inventoryitemList.splice(state.inventoryitemDashboard.inventoryitemList.findIndex(a => a.id === action.payload) , 1);
            state.inventoryitemDashboard.productObj={}
            state.inventoryitemDashboard.selectedId=-1
        },
        setSelectedInventoryitemId: (state, action)=>{
            if (action.payload!==-1){
                state.inventoryitemDashboard.selectedId=action.payload;
                state.inventoryitemDashboard.inventoryitemObj = state.inventoryitemList[
                    state.inventoryitemList.findIndex(inventoryitemObj=>inventoryitemObj.id===parseInt(action.payload))
            ];
            } else {
                state.inventoryitemDashboard.selectedId=action.payload;
                state.inventoryitemDashboard.inventoryitemObj ={}
            }
        },
        setInventoryitemList: (state, action) =>{
            state.inventoryitemList=action.payload;
            state.inventoryitemDashboard.inventoryitemList=action.payload;
        },
        setInventoryitemDashboardInventoryitemList: (state, action) =>{
            state.inventoryitemDashboard.inventoryitemList=action.payload;
        },
        /* Category Reducer methods */
        setCategorySorting: (state, action)=>{
            state.categoryDashboard.sorting=action.payload;
        },
        setCategoryFilterCriteria : (state, action)=>{
            state.categoryDashboard.filterCriteria=action.payload;
        },
        setShowEditForCategory: (state,action)=>{
            state.categoryDashboard.showEdit=action.payload;
            
			state.categoryDashboard.productMappingModalOpen=false;
        },
        addCategoryObj: (state, action)=>{
            state.categoryList.unshift(action.payload);
            state.categoryDashboard.categoryList.unshift(action.payload);

            state.categoryDashboard.categoryObj=action.payload;
            state.categoryDashboard.selectedId=action.payload.id;
        },
        updateCategoryObj: (state, action)=>{
            let index = state.categoryList.map(categoryObj=>categoryObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.categoryList[index]=action.payload;
            }

            index = state.categoryDashboard.categoryList.map(categoryObj=>categoryObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.categoryDashboard.categoryList[index]=action.payload;
            }
            if (state.categoryDashboard.categoryObj!==null){
                state.categoryDashboard.categoryObj = action.payload;
            }
        },
        deleteCategoryObj: (state, action)=>{
            state.categoryList.splice(state.categoryList.findIndex(a => a.id === action.payload) , 1);
            state.categoryDashboard.categoryList.splice(state.categoryDashboard.categoryList.findIndex(a => a.id === action.payload) , 1);
            state.categoryDashboard.productObj={}
            state.categoryDashboard.selectedId=-1
        },
        setSelectedCategoryId: (state, action)=>{
            if (action.payload!==-1){
                state.categoryDashboard.selectedId=action.payload;
                state.categoryDashboard.categoryObj = state.categoryList[
                    state.categoryList.findIndex(categoryObj=>categoryObj.id===parseInt(action.payload))
            ];
            } else {
                state.categoryDashboard.selectedId=action.payload;
                state.categoryDashboard.categoryObj ={}
            }
        },
        setCategoryList: (state, action) =>{
            state.categoryList=action.payload;
            state.categoryDashboard.categoryList=action.payload;
        },
        setCategoryDashboardCategoryList: (state, action) =>{
            state.categoryDashboard.categoryList=action.payload;
        },
      
        setCategoryProductMappingModal:(state,action)=>{
          state.categoryDashboard.productMappingModalOpen=action.payload;
        },
        /* Category2product Reducer methods */
        setCategory2productSorting: (state, action)=>{
            state.category2productDashboard.sorting=action.payload;
        },
        setCategory2productFilterCriteria : (state, action)=>{
            state.category2productDashboard.filterCriteria=action.payload;
        },
        setShowEditForCategory2product: (state,action)=>{
            state.category2productDashboard.showEdit=action.payload;
            
        },
        addCategory2productObj: (state, action)=>{
            state.category2productList.unshift(action.payload);
            state.category2productDashboard.category2productList.unshift(action.payload);

            state.category2productDashboard.category2productObj=action.payload;
            state.category2productDashboard.selectedId=action.payload.id;
        },
        updateCategory2productObj: (state, action)=>{
            let index = state.category2productList.map(category2productObj=>category2productObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.category2productList[index]=action.payload;
            }

            index = state.category2productDashboard.category2productList.map(category2productObj=>category2productObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.category2productDashboard.category2productList[index]=action.payload;
            }
            if (state.category2productDashboard.category2productObj!==null){
                state.category2productDashboard.category2productObj = action.payload;
            }
        },
        deleteCategory2productObj: (state, action)=>{
            state.category2productList.splice(state.category2productList.findIndex(a => a.id === action.payload) , 1);
            state.category2productDashboard.category2productList.splice(state.category2productDashboard.category2productList.findIndex(a => a.id === action.payload) , 1);
            state.category2productDashboard.productObj={}
            state.category2productDashboard.selectedId=-1
        },
        setSelectedCategory2productId: (state, action)=>{
            if (action.payload!==-1){
                state.category2productDashboard.selectedId=action.payload;
                state.category2productDashboard.category2productObj = state.category2productList[
                    state.category2productList.findIndex(category2productObj=>category2productObj.id===parseInt(action.payload))
            ];
            } else {
                state.category2productDashboard.selectedId=action.payload;
                state.category2productDashboard.category2productObj ={}
            }
        },
        setCategory2productList: (state, action) =>{
            state.category2productList=action.payload;
            state.category2productDashboard.category2productList=action.payload;
        },
        setCategory2productDashboardCategory2productList: (state, action) =>{
            state.category2productDashboard.category2productList=action.payload;
        },
        /* Stockoutreq Reducer methods */
        setStockoutreqSorting: (state, action)=>{
            state.stockoutreqDashboard.sorting=action.payload;
        },
        setStockoutreqFilterCriteria : (state, action)=>{
            state.stockoutreqDashboard.filterCriteria=action.payload;
        },
        setShowEditForStockoutreq: (state,action)=>{
            state.stockoutreqDashboard.showEdit=action.payload;
            
			state.stockoutreqDashboard.genStockOutReqModalOpen=false;
			state.stockoutreqDashboard.genPDFpageModalOpen=false;
        },
        addStockoutreqObj: (state, action)=>{
            state.stockoutreqList.unshift(action.payload);
            state.stockoutreqDashboard.stockoutreqList.unshift(action.payload);

            state.stockoutreqDashboard.stockoutreqObj=action.payload;
            state.stockoutreqDashboard.selectedId=action.payload.id;
        },
        updateStockoutreqObj: (state, action)=>{
            let index = state.stockoutreqList.map(stockoutreqObj=>stockoutreqObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.stockoutreqList[index]=action.payload;
            }

            index = state.stockoutreqDashboard.stockoutreqList.map(stockoutreqObj=>stockoutreqObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.stockoutreqDashboard.stockoutreqList[index]=action.payload;
            }
            if (state.stockoutreqDashboard.stockoutreqObj!==null){
                state.stockoutreqDashboard.stockoutreqObj = action.payload;
            }
        },
        deleteStockoutreqObj: (state, action)=>{
            state.stockoutreqList.splice(state.stockoutreqList.findIndex(a => a.id === action.payload) , 1);
            state.stockoutreqDashboard.stockoutreqList.splice(state.stockoutreqDashboard.stockoutreqList.findIndex(a => a.id === action.payload) , 1);
            state.stockoutreqDashboard.productObj={}
            state.stockoutreqDashboard.selectedId=-1
        },
        setSelectedStockoutreqId: (state, action)=>{
            if (action.payload!==-1){
                state.stockoutreqDashboard.selectedId=action.payload;
                state.stockoutreqDashboard.stockoutreqObj = state.stockoutreqList[
                    state.stockoutreqList.findIndex(stockoutreqObj=>stockoutreqObj.id===parseInt(action.payload))
            ];
            } else {
                state.stockoutreqDashboard.selectedId=action.payload;
                state.stockoutreqDashboard.stockoutreqObj ={}
            }
        },
        setStockoutreqList: (state, action) =>{
            state.stockoutreqList=action.payload;
            state.stockoutreqDashboard.stockoutreqList=action.payload;
        },
        setStockoutreqDashboardStockoutreqList: (state, action) =>{
            state.stockoutreqDashboard.stockoutreqList=action.payload;
        },
      
        setStockoutreqGenStockOutReqModal:(state,action)=>{
          state.stockoutreqDashboard.genStockOutReqModalOpen=action.payload;
        },
      
        setStockoutreqGenPDFpageModal:(state,action)=>{
          state.stockoutreqDashboard.genPDFpageModalOpen=action.payload;
        },
        /* Stockoutproduct Reducer methods */
        setStockoutproductSorting: (state, action)=>{
            state.stockoutproductDashboard.sorting=action.payload;
        },
        setStockoutproductFilterCriteria : (state, action)=>{
            state.stockoutproductDashboard.filterCriteria=action.payload;
        },
        setShowEditForStockoutproduct: (state,action)=>{
            state.stockoutproductDashboard.showEdit=action.payload;
            
        },
        addStockoutproductObj: (state, action)=>{
            state.stockoutproductList.unshift(action.payload);
            state.stockoutproductDashboard.stockoutproductList.unshift(action.payload);

            state.stockoutproductDashboard.stockoutproductObj=action.payload;
            state.stockoutproductDashboard.selectedId=action.payload.id;
        },
        updateStockoutproductObj: (state, action)=>{
            let index = state.stockoutproductList.map(stockoutproductObj=>stockoutproductObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.stockoutproductList[index]=action.payload;
            }

            index = state.stockoutproductDashboard.stockoutproductList.map(stockoutproductObj=>stockoutproductObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.stockoutproductDashboard.stockoutproductList[index]=action.payload;
            }
            if (state.stockoutproductDashboard.stockoutproductObj!==null){
                state.stockoutproductDashboard.stockoutproductObj = action.payload;
            }
        },
        deleteStockoutproductObj: (state, action)=>{
            state.stockoutproductList.splice(state.stockoutproductList.findIndex(a => a.id === action.payload) , 1);
            state.stockoutproductDashboard.stockoutproductList.splice(state.stockoutproductDashboard.stockoutproductList.findIndex(a => a.id === action.payload) , 1);
            state.stockoutproductDashboard.productObj={}
            state.stockoutproductDashboard.selectedId=-1
        },
        setSelectedStockoutproductId: (state, action)=>{
            if (action.payload!==-1){
                state.stockoutproductDashboard.selectedId=action.payload;
                state.stockoutproductDashboard.stockoutproductObj = state.stockoutproductList[
                    state.stockoutproductList.findIndex(stockoutproductObj=>stockoutproductObj.id===parseInt(action.payload))
            ];
            } else {
                state.stockoutproductDashboard.selectedId=action.payload;
                state.stockoutproductDashboard.stockoutproductObj ={}
            }
        },
        setStockoutproductList: (state, action) =>{
            state.stockoutproductList=action.payload;
            state.stockoutproductDashboard.stockoutproductList=action.payload;
        },
        setStockoutproductDashboardStockoutproductList: (state, action) =>{
            state.stockoutproductDashboard.stockoutproductList=action.payload;
        },
        /* Stockoutproducttoproductorder Reducer methods */
        setStockoutproducttoproductorderSorting: (state, action)=>{
            state.stockoutproducttoproductorderDashboard.sorting=action.payload;
        },
        setStockoutproducttoproductorderFilterCriteria : (state, action)=>{
            state.stockoutproducttoproductorderDashboard.filterCriteria=action.payload;
        },
        setShowEditForStockoutproducttoproductorder: (state,action)=>{
            state.stockoutproducttoproductorderDashboard.showEdit=action.payload;
            
        },
        addStockoutproducttoproductorderObj: (state, action)=>{
            state.stockoutproducttoproductorderList.unshift(action.payload);
            state.stockoutproducttoproductorderDashboard.stockoutproducttoproductorderList.unshift(action.payload);

            state.stockoutproducttoproductorderDashboard.stockoutproducttoproductorderObj=action.payload;
            state.stockoutproducttoproductorderDashboard.selectedId=action.payload.id;
        },
        updateStockoutproducttoproductorderObj: (state, action)=>{
            let index = state.stockoutproducttoproductorderList.map(stockoutproducttoproductorderObj=>stockoutproducttoproductorderObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.stockoutproducttoproductorderList[index]=action.payload;
            }

            index = state.stockoutproducttoproductorderDashboard.stockoutproducttoproductorderList.map(stockoutproducttoproductorderObj=>stockoutproducttoproductorderObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.stockoutproducttoproductorderDashboard.stockoutproducttoproductorderList[index]=action.payload;
            }
            if (state.stockoutproducttoproductorderDashboard.stockoutproducttoproductorderObj!==null){
                state.stockoutproducttoproductorderDashboard.stockoutproducttoproductorderObj = action.payload;
            }
        },
        deleteStockoutproducttoproductorderObj: (state, action)=>{
            state.stockoutproducttoproductorderList.splice(state.stockoutproducttoproductorderList.findIndex(a => a.id === action.payload) , 1);
            state.stockoutproducttoproductorderDashboard.stockoutproducttoproductorderList.splice(state.stockoutproducttoproductorderDashboard.stockoutproducttoproductorderList.findIndex(a => a.id === action.payload) , 1);
            state.stockoutproducttoproductorderDashboard.productObj={}
            state.stockoutproducttoproductorderDashboard.selectedId=-1
        },
        setSelectedStockoutproducttoproductorderId: (state, action)=>{
            if (action.payload!==-1){
                state.stockoutproducttoproductorderDashboard.selectedId=action.payload;
                state.stockoutproducttoproductorderDashboard.stockoutproducttoproductorderObj = state.stockoutproducttoproductorderList[
                    state.stockoutproducttoproductorderList.findIndex(stockoutproducttoproductorderObj=>stockoutproducttoproductorderObj.id===parseInt(action.payload))
            ];
            } else {
                state.stockoutproducttoproductorderDashboard.selectedId=action.payload;
                state.stockoutproducttoproductorderDashboard.stockoutproducttoproductorderObj ={}
            }
        },
        setStockoutproducttoproductorderList: (state, action) =>{
            state.stockoutproducttoproductorderList=action.payload;
            state.stockoutproducttoproductorderDashboard.stockoutproducttoproductorderList=action.payload;
        },
        setStockoutproducttoproductorderDashboardStockoutproducttoproductorderList: (state, action) =>{
            state.stockoutproducttoproductorderDashboard.stockoutproducttoproductorderList=action.payload;
        },
        /* Stockorder Reducer methods */
        setStockorderSorting: (state, action)=>{
            state.stockorderDashboard.sorting=action.payload;
        },
        setStockorderFilterCriteria : (state, action)=>{
            state.stockorderDashboard.filterCriteria=action.payload;
        },
        setShowEditForStockorder: (state,action)=>{
            state.stockorderDashboard.showEdit=action.payload;
            
			state.stockorderDashboard.AddStockOrderModalOpen=false;
			state.stockorderDashboard.ManageStockOrderModalOpen=false;
			state.stockorderDashboard.PrintStockOrderModalOpen=false;
        },
        addStockorderObj: (state, action)=>{
            state.stockorderList.unshift(action.payload);
            state.stockorderDashboard.stockorderList.unshift(action.payload);

            state.stockorderDashboard.stockorderObj=action.payload;
            state.stockorderDashboard.selectedId=action.payload.id;
        },
        updateStockorderObj: (state, action)=>{
            let index = state.stockorderList.map(stockorderObj=>stockorderObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.stockorderList[index]=action.payload;
            }

            index = state.stockorderDashboard.stockorderList.map(stockorderObj=>stockorderObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.stockorderDashboard.stockorderList[index]=action.payload;
            }
            if (state.stockorderDashboard.stockorderObj!==null){
                state.stockorderDashboard.stockorderObj = action.payload;
            }
        },
        deleteStockorderObj: (state, action)=>{
            state.stockorderList.splice(state.stockorderList.findIndex(a => a.id === action.payload) , 1);
            state.stockorderDashboard.stockorderList.splice(state.stockorderDashboard.stockorderList.findIndex(a => a.id === action.payload) , 1);
            state.stockorderDashboard.productObj={}
            state.stockorderDashboard.selectedId=-1
        },
        setSelectedStockorderId: (state, action)=>{
            if (action.payload!==-1){
                state.stockorderDashboard.selectedId=action.payload;
                state.stockorderDashboard.stockorderObj = state.stockorderList[
                    state.stockorderList.findIndex(stockorderObj=>stockorderObj.id===parseInt(action.payload))
            ];
            } else {
                state.stockorderDashboard.selectedId=action.payload;
                state.stockorderDashboard.stockorderObj ={}
            }
        },
        setStockorderList: (state, action) =>{
            state.stockorderList=action.payload;
            state.stockorderDashboard.stockorderList=action.payload;
        },
        setStockorderDashboardStockorderList: (state, action) =>{
            state.stockorderDashboard.stockorderList=action.payload;
        },
      
        setStockorderAddStockOrderModal:(state,action)=>{
          state.stockorderDashboard.AddStockOrderModalOpen=action.payload;
        },
      
        setStockorderManageStockOrderModal:(state,action)=>{
          state.stockorderDashboard.ManageStockOrderModalOpen=action.payload;
        },
      
        setStockorderPrintStockOrderModal:(state,action)=>{
          state.stockorderDashboard.PrintStockOrderModalOpen=action.payload;
        },
        /* Stockorderproduct Reducer methods */
        setStockorderproductSorting: (state, action)=>{
            state.stockorderproductDashboard.sorting=action.payload;
        },
        setStockorderproductFilterCriteria : (state, action)=>{
            state.stockorderproductDashboard.filterCriteria=action.payload;
        },
        setShowEditForStockorderproduct: (state,action)=>{
            state.stockorderproductDashboard.showEdit=action.payload;
            
			state.stockorderproductDashboard.AddStockProductModalOpen=false;
			state.stockorderproductDashboard.ManageStockProductModalOpen=false;
        },
        addStockorderproductObj: (state, action)=>{
            state.stockorderproductList.unshift(action.payload);
            state.stockorderproductDashboard.stockorderproductList.unshift(action.payload);

            state.stockorderproductDashboard.stockorderproductObj=action.payload;
            state.stockorderproductDashboard.selectedId=action.payload.id;
        },
        updateStockorderproductObj: (state, action)=>{
            let index = state.stockorderproductList.map(stockorderproductObj=>stockorderproductObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.stockorderproductList[index]=action.payload;
            }

            index = state.stockorderproductDashboard.stockorderproductList.map(stockorderproductObj=>stockorderproductObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.stockorderproductDashboard.stockorderproductList[index]=action.payload;
            }
            if (state.stockorderproductDashboard.stockorderproductObj!==null){
                state.stockorderproductDashboard.stockorderproductObj = action.payload;
            }
        },
        deleteStockorderproductObj: (state, action)=>{
            state.stockorderproductList.splice(state.stockorderproductList.findIndex(a => a.id === action.payload) , 1);
            state.stockorderproductDashboard.stockorderproductList.splice(state.stockorderproductDashboard.stockorderproductList.findIndex(a => a.id === action.payload) , 1);
            state.stockorderproductDashboard.productObj={}
            state.stockorderproductDashboard.selectedId=-1
        },
        setSelectedStockorderproductId: (state, action)=>{
            if (action.payload!==-1){
                state.stockorderproductDashboard.selectedId=action.payload;
                state.stockorderproductDashboard.stockorderproductObj = state.stockorderproductList[
                    state.stockorderproductList.findIndex(stockorderproductObj=>stockorderproductObj.id===parseInt(action.payload))
            ];
            } else {
                state.stockorderproductDashboard.selectedId=action.payload;
                state.stockorderproductDashboard.stockorderproductObj ={}
            }
        },
        setStockorderproductList: (state, action) =>{
            state.stockorderproductList=action.payload;
            state.stockorderproductDashboard.stockorderproductList=action.payload;
        },
        setStockorderproductDashboardStockorderproductList: (state, action) =>{
            state.stockorderproductDashboard.stockorderproductList=action.payload;
        },
      
        setStockorderproductAddStockProductModal:(state,action)=>{
          state.stockorderproductDashboard.AddStockProductModalOpen=action.payload;
        },
      
        setStockorderproductManageStockProductModal:(state,action)=>{
          state.stockorderproductDashboard.ManageStockProductModalOpen=action.payload;
        },
        /* Assets Reducer methods */
        setAssetsSorting: (state, action)=>{
            state.assetsDashboard.sorting=action.payload;
        },
        setAssetsFilterCriteria : (state, action)=>{
            state.assetsDashboard.filterCriteria=action.payload;
        },
        setShowEditForAssets: (state,action)=>{
            state.assetsDashboard.showEdit=action.payload;
            
        },
        addAssetsObj: (state, action)=>{
            state.assetsList.unshift(action.payload);
            state.assetsDashboard.assetsList.unshift(action.payload);

            state.assetsDashboard.assetsObj=action.payload;
            state.assetsDashboard.selectedId=action.payload.id;
        },
        updateAssetsObj: (state, action)=>{
            let index = state.assetsList.map(assetsObj=>assetsObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.assetsList[index]=action.payload;
            }

            index = state.assetsDashboard.assetsList.map(assetsObj=>assetsObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.assetsDashboard.assetsList[index]=action.payload;
            }
            if (state.assetsDashboard.assetsObj!==null){
                state.assetsDashboard.assetsObj = action.payload;
            }
        },
        deleteAssetsObj: (state, action)=>{
            state.assetsList.splice(state.assetsList.findIndex(a => a.id === action.payload) , 1);
            state.assetsDashboard.assetsList.splice(state.assetsDashboard.assetsList.findIndex(a => a.id === action.payload) , 1);
            state.assetsDashboard.productObj={}
            state.assetsDashboard.selectedId=-1
        },
        setSelectedAssetsId: (state, action)=>{
            if (action.payload!==-1){
                state.assetsDashboard.selectedId=action.payload;
                state.assetsDashboard.assetsObj = state.assetsList[
                    state.assetsList.findIndex(assetsObj=>assetsObj.id===parseInt(action.payload))
            ];
            } else {
                state.assetsDashboard.selectedId=action.payload;
                state.assetsDashboard.assetsObj ={}
            }
        },
        setAssetsList: (state, action) =>{
            state.assetsList=action.payload;
            state.assetsDashboard.assetsList=action.payload;
        },
        setAssetsDashboardAssetsList: (state, action) =>{
            state.assetsDashboard.assetsList=action.payload;
        },
        /* Audience Reducer methods */
        setAudienceSorting: (state, action)=>{
            state.audienceDashboard.sorting=action.payload;
        },
        setAudienceFilterCriteria : (state, action)=>{
            state.audienceDashboard.filterCriteria=action.payload;
        },
        setShowEditForAudience: (state,action)=>{
            state.audienceDashboard.showEdit=action.payload;
            
        },
        addAudienceObj: (state, action)=>{
            state.audienceList.unshift(action.payload);
            state.audienceDashboard.audienceList.unshift(action.payload);

            state.audienceDashboard.audienceObj=action.payload;
            state.audienceDashboard.selectedId=action.payload.id;
        },
        updateAudienceObj: (state, action)=>{
            let index = state.audienceList.map(audienceObj=>audienceObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.audienceList[index]=action.payload;
            }

            index = state.audienceDashboard.audienceList.map(audienceObj=>audienceObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.audienceDashboard.audienceList[index]=action.payload;
            }
            if (state.audienceDashboard.audienceObj!==null){
                state.audienceDashboard.audienceObj = action.payload;
            }
        },
        deleteAudienceObj: (state, action)=>{
            state.audienceList.splice(state.audienceList.findIndex(a => a.id === action.payload) , 1);
            state.audienceDashboard.audienceList.splice(state.audienceDashboard.audienceList.findIndex(a => a.id === action.payload) , 1);
            state.audienceDashboard.productObj={}
            state.audienceDashboard.selectedId=-1
        },
        setSelectedAudienceId: (state, action)=>{
            if (action.payload!==-1){
                state.audienceDashboard.selectedId=action.payload;
                state.audienceDashboard.audienceObj = state.audienceList[
                    state.audienceList.findIndex(audienceObj=>audienceObj.id===parseInt(action.payload))
            ];
            } else {
                state.audienceDashboard.selectedId=action.payload;
                state.audienceDashboard.audienceObj ={}
            }
        },
        setAudienceList: (state, action) =>{
            state.audienceList=action.payload;
            state.audienceDashboard.audienceList=action.payload;
        },
        setAudienceDashboardAudienceList: (state, action) =>{
            state.audienceDashboard.audienceList=action.payload;
        },
        /* Template Reducer methods */
        setTemplateSorting: (state, action)=>{
            state.templateDashboard.sorting=action.payload;
        },
        setTemplateFilterCriteria : (state, action)=>{
            state.templateDashboard.filterCriteria=action.payload;
        },
        setShowEditForTemplate: (state,action)=>{
            state.templateDashboard.showEdit=action.payload;
            
			state.templateDashboard.TestCampaignModalOpen=false;
			state.templateDashboard.RunCampaignModalOpen=false;
        },
        addTemplateObj: (state, action)=>{
            state.templateList.unshift(action.payload);
            state.templateDashboard.templateList.unshift(action.payload);

            state.templateDashboard.templateObj=action.payload;
            state.templateDashboard.selectedId=action.payload.id;
        },
        updateTemplateObj: (state, action)=>{
            let index = state.templateList.map(templateObj=>templateObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.templateList[index]=action.payload;
            }

            index = state.templateDashboard.templateList.map(templateObj=>templateObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.templateDashboard.templateList[index]=action.payload;
            }
            if (state.templateDashboard.templateObj!==null){
                state.templateDashboard.templateObj = action.payload;
            }
        },
        deleteTemplateObj: (state, action)=>{
            state.templateList.splice(state.templateList.findIndex(a => a.id === action.payload) , 1);
            state.templateDashboard.templateList.splice(state.templateDashboard.templateList.findIndex(a => a.id === action.payload) , 1);
            state.templateDashboard.productObj={}
            state.templateDashboard.selectedId=-1
        },
        setSelectedTemplateId: (state, action)=>{
            if (action.payload!==-1){
                state.templateDashboard.selectedId=action.payload;
                state.templateDashboard.templateObj = state.templateList[
                    state.templateList.findIndex(templateObj=>templateObj.id===parseInt(action.payload))
            ];
            } else {
                state.templateDashboard.selectedId=action.payload;
                state.templateDashboard.templateObj ={}
            }
        },
        setTemplateList: (state, action) =>{
            state.templateList=action.payload;
            state.templateDashboard.templateList=action.payload;
        },
        setTemplateDashboardTemplateList: (state, action) =>{
            state.templateDashboard.templateList=action.payload;
        },
      
        setTemplateTestCampaignModal:(state,action)=>{
          state.templateDashboard.TestCampaignModalOpen=action.payload;
        },
      
        setTemplateRunCampaignModal:(state,action)=>{
          state.templateDashboard.RunCampaignModalOpen=action.payload;
        },
        /* Campaign Reducer methods */
        setCampaignSorting: (state, action)=>{
            state.campaignDashboard.sorting=action.payload;
        },
        setCampaignFilterCriteria : (state, action)=>{
            state.campaignDashboard.filterCriteria=action.payload;
        },
        setShowEditForCampaign: (state,action)=>{
            state.campaignDashboard.showEdit=action.payload;
            
        },
        addCampaignObj: (state, action)=>{
            state.campaignList.unshift(action.payload);
            state.campaignDashboard.campaignList.unshift(action.payload);

            state.campaignDashboard.campaignObj=action.payload;
            state.campaignDashboard.selectedId=action.payload.id;
        },
        updateCampaignObj: (state, action)=>{
            let index = state.campaignList.map(campaignObj=>campaignObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.campaignList[index]=action.payload;
            }

            index = state.campaignDashboard.campaignList.map(campaignObj=>campaignObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.campaignDashboard.campaignList[index]=action.payload;
            }
            if (state.campaignDashboard.campaignObj!==null){
                state.campaignDashboard.campaignObj = action.payload;
            }
        },
        deleteCampaignObj: (state, action)=>{
            state.campaignList.splice(state.campaignList.findIndex(a => a.id === action.payload) , 1);
            state.campaignDashboard.campaignList.splice(state.campaignDashboard.campaignList.findIndex(a => a.id === action.payload) , 1);
            state.campaignDashboard.productObj={}
            state.campaignDashboard.selectedId=-1
        },
        setSelectedCampaignId: (state, action)=>{
            if (action.payload!==-1){
                state.campaignDashboard.selectedId=action.payload;
                state.campaignDashboard.campaignObj = state.campaignList[
                    state.campaignList.findIndex(campaignObj=>campaignObj.id===parseInt(action.payload))
            ];
            } else {
                state.campaignDashboard.selectedId=action.payload;
                state.campaignDashboard.campaignObj ={}
            }
        },
        setCampaignList: (state, action) =>{
            state.campaignList=action.payload;
            state.campaignDashboard.campaignList=action.payload;
        },
        setCampaignDashboardCampaignList: (state, action) =>{
            state.campaignDashboard.campaignList=action.payload;
        },
        /* Campaigncenter Reducer methods */
        setCampaigncenterSorting: (state, action)=>{
            state.campaigncenterDashboard.sorting=action.payload;
        },
        setCampaigncenterFilterCriteria : (state, action)=>{
            state.campaigncenterDashboard.filterCriteria=action.payload;
        },
        setShowEditForCampaigncenter: (state,action)=>{
            state.campaigncenterDashboard.showEdit=action.payload;
            
        },
        addCampaigncenterObj: (state, action)=>{
            state.campaigncenterList.unshift(action.payload);
            state.campaigncenterDashboard.campaigncenterList.unshift(action.payload);

            state.campaigncenterDashboard.campaigncenterObj=action.payload;
            state.campaigncenterDashboard.selectedId=action.payload.id;
        },
        updateCampaigncenterObj: (state, action)=>{
            let index = state.campaigncenterList.map(campaigncenterObj=>campaigncenterObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.campaigncenterList[index]=action.payload;
            }

            index = state.campaigncenterDashboard.campaigncenterList.map(campaigncenterObj=>campaigncenterObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.campaigncenterDashboard.campaigncenterList[index]=action.payload;
            }
            if (state.campaigncenterDashboard.campaigncenterObj!==null){
                state.campaigncenterDashboard.campaigncenterObj = action.payload;
            }
        },
        deleteCampaigncenterObj: (state, action)=>{
            state.campaigncenterList.splice(state.campaigncenterList.findIndex(a => a.id === action.payload) , 1);
            state.campaigncenterDashboard.campaigncenterList.splice(state.campaigncenterDashboard.campaigncenterList.findIndex(a => a.id === action.payload) , 1);
            state.campaigncenterDashboard.productObj={}
            state.campaigncenterDashboard.selectedId=-1
        },
        setSelectedCampaigncenterId: (state, action)=>{
            if (action.payload!==-1){
                state.campaigncenterDashboard.selectedId=action.payload;
                state.campaigncenterDashboard.campaigncenterObj = state.campaigncenterList[
                    state.campaigncenterList.findIndex(campaigncenterObj=>campaigncenterObj.id===parseInt(action.payload))
            ];
            } else {
                state.campaigncenterDashboard.selectedId=action.payload;
                state.campaigncenterDashboard.campaigncenterObj ={}
            }
        },
        setCampaigncenterList: (state, action) =>{
            state.campaigncenterList=action.payload;
            state.campaigncenterDashboard.campaigncenterList=action.payload;
        },
        setCampaigncenterDashboardCampaigncenterList: (state, action) =>{
            state.campaigncenterDashboard.campaigncenterList=action.payload;
        },
        /* Worker Reducer methods */
        setWorkerSorting: (state, action)=>{
            state.workerDashboard.sorting=action.payload;
        },
        setWorkerFilterCriteria : (state, action)=>{
            state.workerDashboard.filterCriteria=action.payload;
        },
        setShowEditForWorker: (state,action)=>{
            state.workerDashboard.showEdit=action.payload;
            
        },
        addWorkerObj: (state, action)=>{
            state.workerList.unshift(action.payload);
            state.workerDashboard.workerList.unshift(action.payload);

            state.workerDashboard.workerObj=action.payload;
            state.workerDashboard.selectedId=action.payload.id;
        },
        updateWorkerObj: (state, action)=>{
            let index = state.workerList.map(workerObj=>workerObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.workerList[index]=action.payload;
            }

            index = state.workerDashboard.workerList.map(workerObj=>workerObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.workerDashboard.workerList[index]=action.payload;
            }
            if (state.workerDashboard.workerObj!==null){
                state.workerDashboard.workerObj = action.payload;
            }
        },
        deleteWorkerObj: (state, action)=>{
            state.workerList.splice(state.workerList.findIndex(a => a.id === action.payload) , 1);
            state.workerDashboard.workerList.splice(state.workerDashboard.workerList.findIndex(a => a.id === action.payload) , 1);
            state.workerDashboard.productObj={}
            state.workerDashboard.selectedId=-1
        },
        setSelectedWorkerId: (state, action)=>{
            if (action.payload!==-1){
                state.workerDashboard.selectedId=action.payload;
                state.workerDashboard.workerObj = state.workerList[
                    state.workerList.findIndex(workerObj=>workerObj.id===parseInt(action.payload))
            ];
            } else {
                state.workerDashboard.selectedId=action.payload;
                state.workerDashboard.workerObj ={}
            }
        },
        setWorkerList: (state, action) =>{
            state.workerList=action.payload;
            state.workerDashboard.workerList=action.payload;
        },
        setWorkerDashboardWorkerList: (state, action) =>{
            state.workerDashboard.workerList=action.payload;
        },
        /* Skill Reducer methods */
        setSkillSorting: (state, action)=>{
            state.skillDashboard.sorting=action.payload;
        },
        setSkillFilterCriteria : (state, action)=>{
            state.skillDashboard.filterCriteria=action.payload;
        },
        setShowEditForSkill: (state,action)=>{
            state.skillDashboard.showEdit=action.payload;
            
        },
        addSkillObj: (state, action)=>{
            state.skillList.unshift(action.payload);
            state.skillDashboard.skillList.unshift(action.payload);

            state.skillDashboard.skillObj=action.payload;
            state.skillDashboard.selectedId=action.payload.id;
        },
        updateSkillObj: (state, action)=>{
            let index = state.skillList.map(skillObj=>skillObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.skillList[index]=action.payload;
            }

            index = state.skillDashboard.skillList.map(skillObj=>skillObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.skillDashboard.skillList[index]=action.payload;
            }
            if (state.skillDashboard.skillObj!==null){
                state.skillDashboard.skillObj = action.payload;
            }
        },
        deleteSkillObj: (state, action)=>{
            state.skillList.splice(state.skillList.findIndex(a => a.id === action.payload) , 1);
            state.skillDashboard.skillList.splice(state.skillDashboard.skillList.findIndex(a => a.id === action.payload) , 1);
            state.skillDashboard.productObj={}
            state.skillDashboard.selectedId=-1
        },
        setSelectedSkillId: (state, action)=>{
            if (action.payload!==-1){
                state.skillDashboard.selectedId=action.payload;
                state.skillDashboard.skillObj = state.skillList[
                    state.skillList.findIndex(skillObj=>skillObj.id===parseInt(action.payload))
            ];
            } else {
                state.skillDashboard.selectedId=action.payload;
                state.skillDashboard.skillObj ={}
            }
        },
        setSkillList: (state, action) =>{
            state.skillList=action.payload;
            state.skillDashboard.skillList=action.payload;
        },
        setSkillDashboardSkillList: (state, action) =>{
            state.skillDashboard.skillList=action.payload;
        },
        /* Explevel Reducer methods */
        setExplevelSorting: (state, action)=>{
            state.explevelDashboard.sorting=action.payload;
        },
        setExplevelFilterCriteria : (state, action)=>{
            state.explevelDashboard.filterCriteria=action.payload;
        },
        setShowEditForExplevel: (state,action)=>{
            state.explevelDashboard.showEdit=action.payload;
            
        },
        addExplevelObj: (state, action)=>{
            state.explevelList.unshift(action.payload);
            state.explevelDashboard.explevelList.unshift(action.payload);

            state.explevelDashboard.explevelObj=action.payload;
            state.explevelDashboard.selectedId=action.payload.id;
        },
        updateExplevelObj: (state, action)=>{
            let index = state.explevelList.map(explevelObj=>explevelObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.explevelList[index]=action.payload;
            }

            index = state.explevelDashboard.explevelList.map(explevelObj=>explevelObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.explevelDashboard.explevelList[index]=action.payload;
            }
            if (state.explevelDashboard.explevelObj!==null){
                state.explevelDashboard.explevelObj = action.payload;
            }
        },
        deleteExplevelObj: (state, action)=>{
            state.explevelList.splice(state.explevelList.findIndex(a => a.id === action.payload) , 1);
            state.explevelDashboard.explevelList.splice(state.explevelDashboard.explevelList.findIndex(a => a.id === action.payload) , 1);
            state.explevelDashboard.productObj={}
            state.explevelDashboard.selectedId=-1
        },
        setSelectedExplevelId: (state, action)=>{
            if (action.payload!==-1){
                state.explevelDashboard.selectedId=action.payload;
                state.explevelDashboard.explevelObj = state.explevelList[
                    state.explevelList.findIndex(explevelObj=>explevelObj.id===parseInt(action.payload))
            ];
            } else {
                state.explevelDashboard.selectedId=action.payload;
                state.explevelDashboard.explevelObj ={}
            }
        },
        setExplevelList: (state, action) =>{
            state.explevelList=action.payload;
            state.explevelDashboard.explevelList=action.payload;
        },
        setExplevelDashboardExplevelList: (state, action) =>{
            state.explevelDashboard.explevelList=action.payload;
        },
        /* Product2skill2exp2rate Reducer methods */
        setProduct2skill2exp2rateSorting: (state, action)=>{
            state.product2skill2exp2rateDashboard.sorting=action.payload;
        },
        setProduct2skill2exp2rateFilterCriteria : (state, action)=>{
            state.product2skill2exp2rateDashboard.filterCriteria=action.payload;
        },
        setShowEditForProduct2skill2exp2rate: (state,action)=>{
            state.product2skill2exp2rateDashboard.showEdit=action.payload;
            
        },
        addProduct2skill2exp2rateObj: (state, action)=>{
            state.product2skill2exp2rateList.unshift(action.payload);
            state.product2skill2exp2rateDashboard.product2skill2exp2rateList.unshift(action.payload);

            state.product2skill2exp2rateDashboard.product2skill2exp2rateObj=action.payload;
            state.product2skill2exp2rateDashboard.selectedId=action.payload.id;
        },
        updateProduct2skill2exp2rateObj: (state, action)=>{
            let index = state.product2skill2exp2rateList.map(product2skill2exp2rateObj=>product2skill2exp2rateObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.product2skill2exp2rateList[index]=action.payload;
            }

            index = state.product2skill2exp2rateDashboard.product2skill2exp2rateList.map(product2skill2exp2rateObj=>product2skill2exp2rateObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.product2skill2exp2rateDashboard.product2skill2exp2rateList[index]=action.payload;
            }
            if (state.product2skill2exp2rateDashboard.product2skill2exp2rateObj!==null){
                state.product2skill2exp2rateDashboard.product2skill2exp2rateObj = action.payload;
            }
        },
        deleteProduct2skill2exp2rateObj: (state, action)=>{
            state.product2skill2exp2rateList.splice(state.product2skill2exp2rateList.findIndex(a => a.id === action.payload) , 1);
            state.product2skill2exp2rateDashboard.product2skill2exp2rateList.splice(state.product2skill2exp2rateDashboard.product2skill2exp2rateList.findIndex(a => a.id === action.payload) , 1);
            state.product2skill2exp2rateDashboard.productObj={}
            state.product2skill2exp2rateDashboard.selectedId=-1
        },
        setSelectedProduct2skill2exp2rateId: (state, action)=>{
            if (action.payload!==-1){
                state.product2skill2exp2rateDashboard.selectedId=action.payload;
                state.product2skill2exp2rateDashboard.product2skill2exp2rateObj = state.product2skill2exp2rateList[
                    state.product2skill2exp2rateList.findIndex(product2skill2exp2rateObj=>product2skill2exp2rateObj.id===parseInt(action.payload))
            ];
            } else {
                state.product2skill2exp2rateDashboard.selectedId=action.payload;
                state.product2skill2exp2rateDashboard.product2skill2exp2rateObj ={}
            }
        },
        setProduct2skill2exp2rateList: (state, action) =>{
            state.product2skill2exp2rateList=action.payload;
            state.product2skill2exp2rateDashboard.product2skill2exp2rateList=action.payload;
        },
        setProduct2skill2exp2rateDashboardProduct2skill2exp2rateList: (state, action) =>{
            state.product2skill2exp2rateDashboard.product2skill2exp2rateList=action.payload;
        },
        /* Stitchingtask Reducer methods */
        setStitchingtaskSorting: (state, action)=>{
            state.stitchingtaskDashboard.sorting=action.payload;
        },
        setStitchingtaskFilterCriteria : (state, action)=>{
            state.stitchingtaskDashboard.filterCriteria=action.payload;
        },
        setShowEditForStitchingtask: (state,action)=>{
            state.stitchingtaskDashboard.showEdit=action.payload;
            
			state.stitchingtaskDashboard.CollectWorkModalOpen=false;
			state.stitchingtaskDashboard.EditRateModalOpen=false;
			state.stitchingtaskDashboard.UpdateWorkerModalOpen=false;
        },
        addStitchingtaskObj: (state, action)=>{
            state.stitchingtaskList.unshift(action.payload);
            state.stitchingtaskDashboard.stitchingtaskList.unshift(action.payload);

            state.stitchingtaskDashboard.stitchingtaskObj=action.payload;
            state.stitchingtaskDashboard.selectedId=action.payload.id;
        },
        updateStitchingtaskObj: (state, action)=>{
            let index = state.stitchingtaskList.map(stitchingtaskObj=>stitchingtaskObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.stitchingtaskList[index]=action.payload;
            }

            index = state.stitchingtaskDashboard.stitchingtaskList.map(stitchingtaskObj=>stitchingtaskObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.stitchingtaskDashboard.stitchingtaskList[index]=action.payload;
            }
            if (state.stitchingtaskDashboard.stitchingtaskObj!==null){
                state.stitchingtaskDashboard.stitchingtaskObj = action.payload;
            }
        },
        deleteStitchingtaskObj: (state, action)=>{
            state.stitchingtaskList.splice(state.stitchingtaskList.findIndex(a => a.id === action.payload) , 1);
            state.stitchingtaskDashboard.stitchingtaskList.splice(state.stitchingtaskDashboard.stitchingtaskList.findIndex(a => a.id === action.payload) , 1);
            state.stitchingtaskDashboard.productObj={}
            state.stitchingtaskDashboard.selectedId=-1
        },
        setSelectedStitchingtaskId: (state, action)=>{
            if (action.payload!==-1){
                state.stitchingtaskDashboard.selectedId=action.payload;
                state.stitchingtaskDashboard.stitchingtaskObj = state.stitchingtaskList[
                    state.stitchingtaskList.findIndex(stitchingtaskObj=>stitchingtaskObj.id===parseInt(action.payload))
            ];
            } else {
                state.stitchingtaskDashboard.selectedId=action.payload;
                state.stitchingtaskDashboard.stitchingtaskObj ={}
            }
        },
        setStitchingtaskList: (state, action) =>{
            state.stitchingtaskList=action.payload;
            state.stitchingtaskDashboard.stitchingtaskList=action.payload;
        },
        setStitchingtaskDashboardStitchingtaskList: (state, action) =>{
            state.stitchingtaskDashboard.stitchingtaskList=action.payload;
        },
      
        setStitchingtaskCollectWorkModal:(state,action)=>{
          state.stitchingtaskDashboard.CollectWorkModalOpen=action.payload;
        },
      
        setStitchingtaskEditRateModal:(state,action)=>{
          state.stitchingtaskDashboard.EditRateModalOpen=action.payload;
        },
      
        setStitchingtaskUpdateWorkerModal:(state,action)=>{
          state.stitchingtaskDashboard.UpdateWorkerModalOpen=action.payload;
        },
        /* Reportdailyorder Reducer methods */
        setReportdailyorderSorting: (state, action)=>{
            state.reportdailyorderDashboard.sorting=action.payload;
        },
        setReportdailyorderFilterCriteria : (state, action)=>{
            state.reportdailyorderDashboard.filterCriteria=action.payload;
        },
        setShowEditForReportdailyorder: (state,action)=>{
            state.reportdailyorderDashboard.showEdit=action.payload;
            
        },
        addReportdailyorderObj: (state, action)=>{
            state.reportdailyorderList.unshift(action.payload);
            state.reportdailyorderDashboard.reportdailyorderList.unshift(action.payload);

            state.reportdailyorderDashboard.reportdailyorderObj=action.payload;
            state.reportdailyorderDashboard.selectedId=action.payload.id;
        },
        updateReportdailyorderObj: (state, action)=>{
            let index = state.reportdailyorderList.map(reportdailyorderObj=>reportdailyorderObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.reportdailyorderList[index]=action.payload;
            }

            index = state.reportdailyorderDashboard.reportdailyorderList.map(reportdailyorderObj=>reportdailyorderObj.id).indexOf(action.payload.id);
            if (index>-1){
                state.reportdailyorderDashboard.reportdailyorderList[index]=action.payload;
            }
            if (state.reportdailyorderDashboard.reportdailyorderObj!==null){
                state.reportdailyorderDashboard.reportdailyorderObj = action.payload;
            }
        },
        deleteReportdailyorderObj: (state, action)=>{
            state.reportdailyorderList.splice(state.reportdailyorderList.findIndex(a => a.id === action.payload) , 1);
            state.reportdailyorderDashboard.reportdailyorderList.splice(state.reportdailyorderDashboard.reportdailyorderList.findIndex(a => a.id === action.payload) , 1);
            state.reportdailyorderDashboard.productObj={}
            state.reportdailyorderDashboard.selectedId=-1
        },
        setSelectedReportdailyorderId: (state, action)=>{
            if (action.payload!==-1){
                state.reportdailyorderDashboard.selectedId=action.payload;
                state.reportdailyorderDashboard.reportdailyorderObj = state.reportdailyorderList[
                    state.reportdailyorderList.findIndex(reportdailyorderObj=>reportdailyorderObj.id===parseInt(action.payload))
            ];
            } else {
                state.reportdailyorderDashboard.selectedId=action.payload;
                state.reportdailyorderDashboard.reportdailyorderObj ={}
            }
        },
        setReportdailyorderList: (state, action) =>{
            state.reportdailyorderList=action.payload;
            state.reportdailyorderDashboard.reportdailyorderList=action.payload;
        },
        setReportdailyorderDashboardReportdailyorderList: (state, action) =>{
            state.reportdailyorderDashboard.reportdailyorderList=action.payload;
        },
    }
});
export const { setActionList, setSelectedActionId, setMfprintingstatusSorting,setMfprintingstatusList,getMfprintingstatusList,updateMfprintingstatusObj,addMfprintingstatusObj,deleteMfprintingstatusObj,
setSelectedMfprintingstatusId,
setMfprintingstatusDashboardMfprintingstatusList,
setShowEditForMfprintingstatus,
setMfprintingstatusFilterCriteria,setMfstitchingstatusSorting,setMfstitchingstatusList,getMfstitchingstatusList,updateMfstitchingstatusObj,addMfstitchingstatusObj,deleteMfstitchingstatusObj,
setSelectedMfstitchingstatusId,
setMfstitchingstatusDashboardMfstitchingstatusList,
setShowEditForMfstitchingstatus,
setMfstitchingstatusFilterCriteria,setMfdigitalstatusSorting,setMfdigitalstatusList,getMfdigitalstatusList,updateMfdigitalstatusObj,addMfdigitalstatusObj,deleteMfdigitalstatusObj,
setSelectedMfdigitalstatusId,
setMfdigitalstatusDashboardMfdigitalstatusList,
setShowEditForMfdigitalstatus,
setMfdigitalstatusFilterCriteria,setMfdeliveryprioritySorting,setMfdeliverypriorityList,getMfdeliverypriorityList,updateMfdeliverypriorityObj,addMfdeliverypriorityObj,deleteMfdeliverypriorityObj,
setSelectedMfdeliverypriorityId,
setMfdeliverypriorityDashboardMfdeliverypriorityList,
setShowEditForMfdeliverypriority,
setMfdeliverypriorityFilterCriteria,setMfprintingtypeSorting,setMfprintingtypeList,getMfprintingtypeList,updateMfprintingtypeObj,addMfprintingtypeObj,deleteMfprintingtypeObj,
setSelectedMfprintingtypeId,
setMfprintingtypeDashboardMfprintingtypeList,
setShowEditForMfprintingtype,
setMfprintingtypeFilterCriteria,setMforderstatusSorting,setMforderstatusList,getMforderstatusList,updateMforderstatusObj,addMforderstatusObj,deleteMforderstatusObj,
setSelectedMforderstatusId,
setMforderstatusDashboardMforderstatusList,
setShowEditForMforderstatus,
setMforderstatusFilterCriteria,setMforderSorting,setMforderList,getMforderList,updateMforderObj,addMforderObj,deleteMforderObj,
setSelectedMforderId,
setMforderDashboardMforderList,
setShowEditForMforder,
setMforderFilterCriteria,
setMforderUpdateMfOrderStatusModal,
setMforderManageMfOrderModal,
setMforderAddMfOrderModal,
setMforderAddMfProductModal,
setMforderOrderToFactoryModal,
setMforderUpdateRemarksModal,
setMforderShowProgressModal,
setMforderPrintJobTicketModal,
setMforderEditOrderInfoModal,setMfpartySorting,setMfpartyList,getMfpartyList,updateMfpartyObj,addMfpartyObj,deleteMfpartyObj,
setSelectedMfpartyId,
setMfpartyDashboardMfpartyList,
setShowEditForMfparty,
setMfpartyFilterCriteria,
setMfpartyManagePartyModal,
setMfpartySelectPartyModal,setMfproductorderSorting,setMfproductorderList,getMfproductorderList,updateMfproductorderObj,addMfproductorderObj,deleteMfproductorderObj,
setSelectedMfproductorderId,
setMfproductorderDashboardMfproductorderList,
setShowEditForMfproductorder,
setMfproductorderFilterCriteria,
setMfproductorderUpdateProductOrderStatusModal,
setMfproductorderAddMfProductOrderModal,
setMfproductorderUpdateProductOrderModal,
setMfproductorderCancelProductOrderModal,setMfproductSorting,setMfproductList,getMfproductList,updateMfproductObj,addMfproductObj,deleteMfproductObj,
setSelectedMfproductId,
setMfproductDashboardMfproductList,
setShowEditForMfproduct,
setMfproductFilterCriteria,
setMfproductAttachImageModal,
setMfproductManageProductModal,
setMfproductLinkAssetModal,
setMfproductManageAssetsModal,
setMfproductAssetViewerModal,
setMfproductSendWhatisupMsgModal,setMfproductorderstatusSorting,setMfproductorderstatusList,getMfproductorderstatusList,updateMfproductorderstatusObj,addMfproductorderstatusObj,deleteMfproductorderstatusObj,
setSelectedMfproductorderstatusId,
setMfproductorderstatusDashboardMfproductorderstatusList,
setShowEditForMfproductorderstatus,
setMfproductorderstatusFilterCriteria,setBusinessprocessSorting,setBusinessprocessList,getBusinessprocessList,updateBusinessprocessObj,addBusinessprocessObj,deleteBusinessprocessObj,
setSelectedBusinessprocessId,
setBusinessprocessDashboardBusinessprocessList,
setShowEditForBusinessprocess,
setBusinessprocessFilterCriteria,
setBusinessprocessTaskMgmtModal,setTaskSorting,setTaskList,getTaskList,updateTaskObj,addTaskObj,deleteTaskObj,
setSelectedTaskId,
setTaskDashboardTaskList,
setShowEditForTask,
setTaskFilterCriteria,setTaskinstanceSorting,setTaskinstanceList,getTaskinstanceList,updateTaskinstanceObj,addTaskinstanceObj,deleteTaskinstanceObj,
setSelectedTaskinstanceId,
setTaskinstanceDashboardTaskinstanceList,
setShowEditForTaskinstance,
setTaskinstanceFilterCriteria,
setTaskinstanceUpdateStatusModal,setTasktypeSorting,setTasktypeList,getTasktypeList,updateTasktypeObj,addTasktypeObj,deleteTasktypeObj,
setSelectedTasktypeId,
setTasktypeDashboardTasktypeList,
setShowEditForTasktype,
setTasktypeFilterCriteria,setFactoryroleSorting,setFactoryroleList,getFactoryroleList,updateFactoryroleObj,addFactoryroleObj,deleteFactoryroleObj,
setSelectedFactoryroleId,
setFactoryroleDashboardFactoryroleList,
setShowEditForFactoryrole,
setFactoryroleFilterCriteria,setTaskstatusSorting,setTaskstatusList,getTaskstatusList,updateTaskstatusObj,addTaskstatusObj,deleteTaskstatusObj,
setSelectedTaskstatusId,
setTaskstatusDashboardTaskstatusList,
setShowEditForTaskstatus,
setTaskstatusFilterCriteria,setInventorySorting,setInventoryList,getInventoryList,updateInventoryObj,addInventoryObj,deleteInventoryObj,
setSelectedInventoryId,
setInventoryDashboardInventoryList,
setShowEditForInventory,
setInventoryFilterCriteria,
setInventoryMannageInventoryModal,setInventoryitemSorting,setInventoryitemList,getInventoryitemList,updateInventoryitemObj,addInventoryitemObj,deleteInventoryitemObj,
setSelectedInventoryitemId,
setInventoryitemDashboardInventoryitemList,
setShowEditForInventoryitem,
setInventoryitemFilterCriteria,setCategorySorting,setCategoryList,getCategoryList,updateCategoryObj,addCategoryObj,deleteCategoryObj,
setSelectedCategoryId,
setCategoryDashboardCategoryList,
setShowEditForCategory,
setCategoryFilterCriteria,
setCategoryProductMappingModal,setCategory2productSorting,setCategory2productList,getCategory2productList,updateCategory2productObj,addCategory2productObj,deleteCategory2productObj,
setSelectedCategory2productId,
setCategory2productDashboardCategory2productList,
setShowEditForCategory2product,
setCategory2productFilterCriteria,setStockoutreqSorting,setStockoutreqList,getStockoutreqList,updateStockoutreqObj,addStockoutreqObj,deleteStockoutreqObj,
setSelectedStockoutreqId,
setStockoutreqDashboardStockoutreqList,
setShowEditForStockoutreq,
setStockoutreqFilterCriteria,
setStockoutreqGenStockOutReqModal,
setStockoutreqGenPDFpageModal,setStockoutproductSorting,setStockoutproductList,getStockoutproductList,updateStockoutproductObj,addStockoutproductObj,deleteStockoutproductObj,
setSelectedStockoutproductId,
setStockoutproductDashboardStockoutproductList,
setShowEditForStockoutproduct,
setStockoutproductFilterCriteria,setStockoutproducttoproductorderSorting,setStockoutproducttoproductorderList,getStockoutproducttoproductorderList,updateStockoutproducttoproductorderObj,addStockoutproducttoproductorderObj,deleteStockoutproducttoproductorderObj,
setSelectedStockoutproducttoproductorderId,
setStockoutproducttoproductorderDashboardStockoutproducttoproductorderList,
setShowEditForStockoutproducttoproductorder,
setStockoutproducttoproductorderFilterCriteria,setStockorderSorting,setStockorderList,getStockorderList,updateStockorderObj,addStockorderObj,deleteStockorderObj,
setSelectedStockorderId,
setStockorderDashboardStockorderList,
setShowEditForStockorder,
setStockorderFilterCriteria,
setStockorderAddStockOrderModal,
setStockorderManageStockOrderModal,
setStockorderPrintStockOrderModal,setStockorderproductSorting,setStockorderproductList,getStockorderproductList,updateStockorderproductObj,addStockorderproductObj,deleteStockorderproductObj,
setSelectedStockorderproductId,
setStockorderproductDashboardStockorderproductList,
setShowEditForStockorderproduct,
setStockorderproductFilterCriteria,
setStockorderproductAddStockProductModal,
setStockorderproductManageStockProductModal,setAssetsSorting,setAssetsList,getAssetsList,updateAssetsObj,addAssetsObj,deleteAssetsObj,
setSelectedAssetsId,
setAssetsDashboardAssetsList,
setShowEditForAssets,
setAssetsFilterCriteria,setAudienceSorting,setAudienceList,getAudienceList,updateAudienceObj,addAudienceObj,deleteAudienceObj,
setSelectedAudienceId,
setAudienceDashboardAudienceList,
setShowEditForAudience,
setAudienceFilterCriteria,setTemplateSorting,setTemplateList,getTemplateList,updateTemplateObj,addTemplateObj,deleteTemplateObj,
setSelectedTemplateId,
setTemplateDashboardTemplateList,
setShowEditForTemplate,
setTemplateFilterCriteria,
setTemplateTestCampaignModal,
setTemplateRunCampaignModal,setCampaignSorting,setCampaignList,getCampaignList,updateCampaignObj,addCampaignObj,deleteCampaignObj,
setSelectedCampaignId,
setCampaignDashboardCampaignList,
setShowEditForCampaign,
setCampaignFilterCriteria,setCampaigncenterSorting,setCampaigncenterList,getCampaigncenterList,updateCampaigncenterObj,addCampaigncenterObj,deleteCampaigncenterObj,
setSelectedCampaigncenterId,
setCampaigncenterDashboardCampaigncenterList,
setShowEditForCampaigncenter,
setCampaigncenterFilterCriteria,setWorkerSorting,setWorkerList,getWorkerList,updateWorkerObj,addWorkerObj,deleteWorkerObj,
setSelectedWorkerId,
setWorkerDashboardWorkerList,
setShowEditForWorker,
setWorkerFilterCriteria,setSkillSorting,setSkillList,getSkillList,updateSkillObj,addSkillObj,deleteSkillObj,
setSelectedSkillId,
setSkillDashboardSkillList,
setShowEditForSkill,
setSkillFilterCriteria,setExplevelSorting,setExplevelList,getExplevelList,updateExplevelObj,addExplevelObj,deleteExplevelObj,
setSelectedExplevelId,
setExplevelDashboardExplevelList,
setShowEditForExplevel,
setExplevelFilterCriteria,setProduct2skill2exp2rateSorting,setProduct2skill2exp2rateList,getProduct2skill2exp2rateList,updateProduct2skill2exp2rateObj,addProduct2skill2exp2rateObj,deleteProduct2skill2exp2rateObj,
setSelectedProduct2skill2exp2rateId,
setProduct2skill2exp2rateDashboardProduct2skill2exp2rateList,
setShowEditForProduct2skill2exp2rate,
setProduct2skill2exp2rateFilterCriteria,setStitchingtaskSorting,setStitchingtaskList,getStitchingtaskList,updateStitchingtaskObj,addStitchingtaskObj,deleteStitchingtaskObj,
setSelectedStitchingtaskId,
setStitchingtaskDashboardStitchingtaskList,
setShowEditForStitchingtask,
setStitchingtaskFilterCriteria,
setStitchingtaskCollectWorkModal,
setStitchingtaskEditRateModal,
setStitchingtaskUpdateWorkerModal,setReportdailyorderSorting,setReportdailyorderList,getReportdailyorderList,updateReportdailyorderObj,addReportdailyorderObj,deleteReportdailyorderObj,
setSelectedReportdailyorderId,
setReportdailyorderDashboardReportdailyorderList,
setShowEditForReportdailyorder,
setReportdailyorderFilterCriteria, } = ManufSlice.actions;
export default ManufSlice.reducer;